"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EmojiList = [{
  unicode: '1f47e',
  shortname: ':space_invader:',
  category: 'activity'
}, {
  unicode: '1f574',
  shortname: ':levitate:',
  category: 'activity'
}, {
  unicode: '1f93a',
  shortname: ':fencer:',
  category: 'activity'
}, {
  unicode: '1f3c7',
  shortname: ':horse_racing:',
  category: 'activity'
}, {
  unicode: '1f3c7-1f3fb',
  shortname: ':horse_racing_tone1:',
  category: 'activity'
}, {
  unicode: '1f3c7-1f3fc',
  shortname: ':horse_racing_tone2:',
  category: 'activity'
}, {
  unicode: '1f3c7-1f3fd',
  shortname: ':horse_racing_tone3:',
  category: 'activity'
}, {
  unicode: '1f3c7-1f3fe',
  shortname: ':horse_racing_tone4:',
  category: 'activity'
}, {
  unicode: '1f3c7-1f3ff',
  shortname: ':horse_racing_tone5:',
  category: 'activity'
}, {
  unicode: '26f7',
  shortname: ':skier:',
  category: 'activity'
}, {
  unicode: '1f3c2',
  shortname: ':snowboarder:',
  category: 'activity'
}, {
  unicode: '1f3cc',
  shortname: ':golfer:',
  category: 'activity'
}, {
  unicode: '1f3c4',
  shortname: ':surfer:',
  category: 'activity'
}, {
  unicode: '1f3c4-1f3fb',
  shortname: ':surfer_tone1:',
  category: 'activity'
}, {
  unicode: '1f3c4-1f3fc',
  shortname: ':surfer_tone2:',
  category: 'activity'
}, {
  unicode: '1f3c4-1f3fd',
  shortname: ':surfer_tone3:',
  category: 'activity'
}, {
  unicode: '1f3c4-1f3fe',
  shortname: ':surfer_tone4:',
  category: 'activity'
}, {
  unicode: '1f3c4-1f3ff',
  shortname: ':surfer_tone5:',
  category: 'activity'
}, {
  unicode: '1f6a3',
  shortname: ':rowboat:',
  category: 'activity'
}, {
  unicode: '1f6a3-1f3fb',
  shortname: ':rowboat_tone1:',
  category: 'activity'
}, {
  unicode: '1f6a3-1f3fc',
  shortname: ':rowboat_tone2:',
  category: 'activity'
}, {
  unicode: '1f6a3-1f3fd',
  shortname: ':rowboat_tone3:',
  category: 'activity'
}, {
  unicode: '1f6a3-1f3fe',
  shortname: ':rowboat_tone4:',
  category: 'activity'
}, {
  unicode: '1f6a3-1f3ff',
  shortname: ':rowboat_tone5:',
  category: 'activity'
}, {
  unicode: '1f3ca',
  shortname: ':swimmer:',
  category: 'activity'
}, {
  unicode: '1f3ca-1f3fb',
  shortname: ':swimmer_tone1:',
  category: 'activity'
}, {
  unicode: '1f3ca-1f3fc',
  shortname: ':swimmer_tone2:',
  category: 'activity'
}, {
  unicode: '1f3ca-1f3fd',
  shortname: ':swimmer_tone3:',
  category: 'activity'
}, {
  unicode: '1f3ca-1f3fe',
  shortname: ':swimmer_tone4:',
  category: 'activity'
}, {
  unicode: '1f3ca-1f3ff',
  shortname: ':swimmer_tone5:',
  category: 'activity'
}, {
  unicode: '26f9',
  shortname: ':basketball_player:',
  category: 'activity'
}, {
  unicode: '26f9-1f3fb',
  shortname: ':basketball_player_tone1:',
  category: 'activity'
}, {
  unicode: '26f9-1f3fc',
  shortname: ':basketball_player_tone2:',
  category: 'activity'
}, {
  unicode: '26f9-1f3fd',
  shortname: ':basketball_player_tone3:',
  category: 'activity'
}, {
  unicode: '26f9-1f3fe',
  shortname: ':basketball_player_tone4:',
  category: 'activity'
}, {
  unicode: '26f9-1f3ff',
  shortname: ':basketball_player_tone5:',
  category: 'activity'
}, {
  unicode: '1f3cb',
  shortname: ':lifter:',
  category: 'activity'
}, {
  unicode: '1f3cb-1f3fb',
  shortname: ':lifter_tone1:',
  category: 'activity'
}, {
  unicode: '1f3cb-1f3fc',
  shortname: ':lifter_tone2:',
  category: 'activity'
}, {
  unicode: '1f3cb-1f3fd',
  shortname: ':lifter_tone3:',
  category: 'activity'
}, {
  unicode: '1f3cb-1f3fe',
  shortname: ':lifter_tone4:',
  category: 'activity'
}, {
  unicode: '1f3cb-1f3ff',
  shortname: ':lifter_tone5:',
  category: 'activity'
}, {
  unicode: '1f6b4',
  shortname: ':bicyclist:',
  category: 'activity'
}, {
  unicode: '1f6b4-1f3fb',
  shortname: ':bicyclist_tone1:',
  category: 'activity'
}, {
  unicode: '1f6b4-1f3fc',
  shortname: ':bicyclist_tone2:',
  category: 'activity'
}, {
  unicode: '1f6b4-1f3fd',
  shortname: ':bicyclist_tone3:',
  category: 'activity'
}, {
  unicode: '1f6b4-1f3fe',
  shortname: ':bicyclist_tone4:',
  category: 'activity'
}, {
  unicode: '1f6b4-1f3ff',
  shortname: ':bicyclist_tone5:',
  category: 'activity'
}, {
  unicode: '1f6b5',
  shortname: ':mountain_bicyclist:',
  category: 'activity'
}, {
  unicode: '1f6b5-1f3fb',
  shortname: ':mountain_bicyclist_tone1:',
  category: 'activity'
}, {
  unicode: '1f6b5-1f3fc',
  shortname: ':mountain_bicyclist_tone2:',
  category: 'activity'
}, {
  unicode: '1f6b5-1f3fd',
  shortname: ':mountain_bicyclist_tone3:',
  category: 'activity'
}, {
  unicode: '1f6b5-1f3fe',
  shortname: ':mountain_bicyclist_tone4:',
  category: 'activity'
}, {
  unicode: '1f6b5-1f3ff',
  shortname: ':mountain_bicyclist_tone5:',
  category: 'activity'
}, {
  unicode: '1f938',
  shortname: ':cartwheel:',
  category: 'activity'
}, {
  unicode: '1f938-1f3fb',
  shortname: ':cartwheel_tone1:',
  category: 'activity'
}, {
  unicode: '1f938-1f3fc',
  shortname: ':cartwheel_tone2:',
  category: 'activity'
}, {
  unicode: '1f938-1f3fd',
  shortname: ':cartwheel_tone3:',
  category: 'activity'
}, {
  unicode: '1f938-1f3fe',
  shortname: ':cartwheel_tone4:',
  category: 'activity'
}, {
  unicode: '1f938-1f3ff',
  shortname: ':cartwheel_tone5:',
  category: 'activity'
}, {
  unicode: '1f93c',
  shortname: ':wrestlers:',
  category: 'activity'
}, {
  unicode: '1f93c-1f3fb',
  shortname: ':wrestlers_tone1:',
  category: 'activity'
}, {
  unicode: '1f93c-1f3fc',
  shortname: ':wrestlers_tone2:',
  category: 'activity'
}, {
  unicode: '1f93c-1f3fd',
  shortname: ':wrestlers_tone3:',
  category: 'activity'
}, {
  unicode: '1f93c-1f3fe',
  shortname: ':wrestlers_tone4:',
  category: 'activity'
}, {
  unicode: '1f93c-1f3ff',
  shortname: ':wrestlers_tone5:',
  category: 'activity'
}, {
  unicode: '1f93d',
  shortname: ':water_polo:',
  category: 'activity'
}, {
  unicode: '1f93d-1f3fb',
  shortname: ':water_polo_tone1:',
  category: 'activity'
}, {
  unicode: '1f93d-1f3fc',
  shortname: ':water_polo_tone2:',
  category: 'activity'
}, {
  unicode: '1f93d-1f3fd',
  shortname: ':water_polo_tone3:',
  category: 'activity'
}, {
  unicode: '1f93d-1f3fe',
  shortname: ':water_polo_tone4:',
  category: 'activity'
}, {
  unicode: '1f93d-1f3ff',
  shortname: ':water_polo_tone5:',
  category: 'activity'
}, {
  unicode: '1f93e',
  shortname: ':handball:',
  category: 'activity'
}, {
  unicode: '1f93e-1f3fb',
  shortname: ':handball_tone1:',
  category: 'activity'
}, {
  unicode: '1f93e-1f3fc',
  shortname: ':handball_tone2:',
  category: 'activity'
}, {
  unicode: '1f93e-1f3fd',
  shortname: ':handball_tone3:',
  category: 'activity'
}, {
  unicode: '1f93e-1f3fe',
  shortname: ':handball_tone4:',
  category: 'activity'
}, {
  unicode: '1f93e-1f3ff',
  shortname: ':handball_tone5:',
  category: 'activity'
}, {
  unicode: '1f939',
  shortname: ':juggling:',
  category: 'activity'
}, {
  unicode: '1f939-1f3fb',
  shortname: ':juggling_tone1:',
  category: 'activity'
}, {
  unicode: '1f939-1f3fc',
  shortname: ':juggling_tone2:',
  category: 'activity'
}, {
  unicode: '1f939-1f3fd',
  shortname: ':juggling_tone3:',
  category: 'activity'
}, {
  unicode: '1f939-1f3fe',
  shortname: ':juggling_tone4:',
  category: 'activity'
}, {
  unicode: '1f939-1f3ff',
  shortname: ':juggling_tone5:',
  category: 'activity'
}, {
  unicode: '1f3aa',
  shortname: ':circus_tent:',
  category: 'activity'
}, {
  unicode: '1f3ad',
  shortname: ':performing_arts:',
  category: 'activity'
}, {
  unicode: '1f3a8',
  shortname: ':art:',
  category: 'activity'
}, {
  unicode: '1f3b0',
  shortname: ':slot_machine:',
  category: 'activity'
}, {
  unicode: '1f6c0',
  shortname: ':bath:',
  category: 'activity'
}, {
  unicode: '1f6c0-1f3fb',
  shortname: ':bath_tone1:',
  category: 'activity'
}, {
  unicode: '1f6c0-1f3fc',
  shortname: ':bath_tone2:',
  category: 'activity'
}, {
  unicode: '1f6c0-1f3fd',
  shortname: ':bath_tone3:',
  category: 'activity'
}, {
  unicode: '1f6c0-1f3fe',
  shortname: ':bath_tone4:',
  category: 'activity'
}, {
  unicode: '1f6c0-1f3ff',
  shortname: ':bath_tone5:',
  category: 'activity'
}, {
  unicode: '1f397',
  shortname: ':reminder_ribbon:',
  category: 'activity'
}, {
  unicode: '1f39f',
  shortname: ':tickets:',
  category: 'activity'
}, {
  unicode: '1f3ab',
  shortname: ':ticket:',
  category: 'activity'
}, {
  unicode: '1f396',
  shortname: ':military_medal:',
  category: 'activity'
}, {
  unicode: '1f3c6',
  shortname: ':trophy:',
  category: 'activity'
}, {
  unicode: '1f3c5',
  shortname: ':medal:',
  category: 'activity'
}, {
  unicode: '1f947',
  shortname: ':first_place:',
  category: 'activity'
}, {
  unicode: '1f948',
  shortname: ':second_place:',
  category: 'activity'
}, {
  unicode: '1f949',
  shortname: ':third_place:',
  category: 'activity'
}, {
  unicode: '26bd',
  shortname: ':soccer:',
  category: 'activity'
}, {
  unicode: '26be',
  shortname: ':baseball:',
  category: 'activity'
}, {
  unicode: '1f3c0',
  shortname: ':basketball:',
  category: 'activity'
}, {
  unicode: '1f3d0',
  shortname: ':volleyball:',
  category: 'activity'
}, {
  unicode: '1f3c8',
  shortname: ':football:',
  category: 'activity'
}, {
  unicode: '1f3c9',
  shortname: ':rugby_football:',
  category: 'activity'
}, {
  unicode: '1f3be',
  shortname: ':tennis:',
  category: 'activity'
}, {
  unicode: '1f3b1',
  shortname: ':8ball:',
  category: 'activity'
}, {
  unicode: '1f3b3',
  shortname: ':bowling:',
  category: 'activity'
}, {
  unicode: '1f3cf',
  shortname: ':cricket:',
  category: 'activity'
}, {
  unicode: '1f3d1',
  shortname: ':field_hockey:',
  category: 'activity'
}, {
  unicode: '1f3d2',
  shortname: ':hockey:',
  category: 'activity'
}, {
  unicode: '1f3d3',
  shortname: ':ping_pong:',
  category: 'activity'
}, {
  unicode: '1f3f8',
  shortname: ':badminton:',
  category: 'activity'
}, {
  unicode: '1f94a',
  shortname: ':boxing_glove:',
  category: 'activity'
}, {
  unicode: '1f94b',
  shortname: ':martial_arts_uniform:',
  category: 'activity'
}, {
  unicode: '1f945',
  shortname: ':goal:',
  category: 'activity'
}, {
  unicode: '1f3af',
  shortname: ':dart:',
  category: 'activity'
}, {
  unicode: '26f3',
  shortname: ':golf:',
  category: 'activity'
}, {
  unicode: '26f8',
  shortname: ':ice_skate:',
  category: 'activity'
}, {
  unicode: '1f3a3',
  shortname: ':fishing_pole_and_fish:',
  category: 'activity'
}, {
  unicode: '1f3bd',
  shortname: ':running_shirt_with_sash:',
  category: 'activity'
}, {
  unicode: '1f3bf',
  shortname: ':ski:',
  category: 'activity'
}, {
  unicode: '1f3ae',
  shortname: ':video_game:',
  category: 'activity'
}, {
  unicode: '1f3b2',
  shortname: ':game_die:',
  category: 'activity'
}, {
  unicode: '1f3bc',
  shortname: ':musical_score:',
  category: 'activity'
}, {
  unicode: '1f3a4',
  shortname: ':microphone:',
  category: 'activity'
}, {
  unicode: '1f3a7',
  shortname: ':headphones:',
  category: 'activity'
}, {
  unicode: '1f3b7',
  shortname: ':saxophone:',
  category: 'activity'
}, {
  unicode: '1f3b8',
  shortname: ':guitar:',
  category: 'activity'
}, {
  unicode: '1f3b9',
  shortname: ':musical_keyboard:',
  category: 'activity'
}, {
  unicode: '1f3ba',
  shortname: ':trumpet:',
  category: 'activity'
}, {
  unicode: '1f3bb',
  shortname: ':violin:',
  category: 'activity'
}, {
  unicode: '1f941',
  shortname: ':drum:',
  category: 'activity'
}, {
  unicode: '1f3ac',
  shortname: ':clapper:',
  category: 'activity'
}, {
  unicode: '1f3f9',
  shortname: ':bow_and_arrow:',
  category: 'activity'
}, {
  unicode: '1f1e6-1f1e8',
  shortname: ':flag_ac:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1e9',
  shortname: ':flag_ad:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1ea',
  shortname: ':flag_ae:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1eb',
  shortname: ':flag_af:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1ec',
  shortname: ':flag_ag:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1ee',
  shortname: ':flag_ai:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1f1',
  shortname: ':flag_al:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1f2',
  shortname: ':flag_am:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1f4',
  shortname: ':flag_ao:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1f6',
  shortname: ':flag_aq:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1f7',
  shortname: ':flag_ar:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1f8',
  shortname: ':flag_as:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1f9',
  shortname: ':flag_at:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1fa',
  shortname: ':flag_au:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1fc',
  shortname: ':flag_aw:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1fd',
  shortname: ':flag_ax:',
  category: 'flags'
}, {
  unicode: '1f1e6-1f1ff',
  shortname: ':flag_az:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1e6',
  shortname: ':flag_ba:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1e7',
  shortname: ':flag_bb:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1e9',
  shortname: ':flag_bd:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1ea',
  shortname: ':flag_be:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1eb',
  shortname: ':flag_bf:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1ec',
  shortname: ':flag_bg:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1ed',
  shortname: ':flag_bh:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1ee',
  shortname: ':flag_bi:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1ef',
  shortname: ':flag_bj:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1f1',
  shortname: ':flag_bl:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1f2',
  shortname: ':flag_bm:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1f3',
  shortname: ':flag_bn:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1f4',
  shortname: ':flag_bo:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1f6',
  shortname: ':flag_bq:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1f7',
  shortname: ':flag_br:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1f8',
  shortname: ':flag_bs:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1f9',
  shortname: ':flag_bt:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1fb',
  shortname: ':flag_bv:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1fc',
  shortname: ':flag_bw:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1fe',
  shortname: ':flag_by:',
  category: 'flags'
}, {
  unicode: '1f1e7-1f1ff',
  shortname: ':flag_bz:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1e6',
  shortname: ':flag_ca:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1e8',
  shortname: ':flag_cc:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1e9',
  shortname: ':flag_cd:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1eb',
  shortname: ':flag_cf:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1ec',
  shortname: ':flag_cg:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1ed',
  shortname: ':flag_ch:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1ee',
  shortname: ':flag_ci:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1f0',
  shortname: ':flag_ck:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1f1',
  shortname: ':flag_cl:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1f2',
  shortname: ':flag_cm:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1f3',
  shortname: ':flag_cn:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1f4',
  shortname: ':flag_co:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1f5',
  shortname: ':flag_cp:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1f7',
  shortname: ':flag_cr:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1fa',
  shortname: ':flag_cu:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1fb',
  shortname: ':flag_cv:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1fc',
  shortname: ':flag_cw:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1fd',
  shortname: ':flag_cx:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1fe',
  shortname: ':flag_cy:',
  category: 'flags'
}, {
  unicode: '1f1e8-1f1ff',
  shortname: ':flag_cz:',
  category: 'flags'
}, {
  unicode: '1f1e9-1f1ea',
  shortname: ':flag_de:',
  category: 'flags'
}, {
  unicode: '1f1e9-1f1ec',
  shortname: ':flag_dg:',
  category: 'flags'
}, {
  unicode: '1f1e9-1f1ef',
  shortname: ':flag_dj:',
  category: 'flags'
}, {
  unicode: '1f1e9-1f1f0',
  shortname: ':flag_dk:',
  category: 'flags'
}, {
  unicode: '1f1e9-1f1f2',
  shortname: ':flag_dm:',
  category: 'flags'
}, {
  unicode: '1f1e9-1f1f4',
  shortname: ':flag_do:',
  category: 'flags'
}, {
  unicode: '1f1e9-1f1ff',
  shortname: ':flag_dz:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1e6',
  shortname: ':flag_ea:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1e8',
  shortname: ':flag_ec:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1ea',
  shortname: ':flag_ee:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1ec',
  shortname: ':flag_eg:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1ed',
  shortname: ':flag_eh:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1f7',
  shortname: ':flag_er:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1f8',
  shortname: ':flag_es:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1f9',
  shortname: ':flag_et:',
  category: 'flags'
}, {
  unicode: '1f1ea-1f1fa',
  shortname: ':flag_eu:',
  category: 'flags'
}, {
  unicode: '1f1eb-1f1ee',
  shortname: ':flag_fi:',
  category: 'flags'
}, {
  unicode: '1f1eb-1f1ef',
  shortname: ':flag_fj:',
  category: 'flags'
}, {
  unicode: '1f1eb-1f1f0',
  shortname: ':flag_fk:',
  category: 'flags'
}, {
  unicode: '1f1eb-1f1f2',
  shortname: ':flag_fm:',
  category: 'flags'
}, {
  unicode: '1f1eb-1f1f4',
  shortname: ':flag_fo:',
  category: 'flags'
}, {
  unicode: '1f1eb-1f1f7',
  shortname: ':flag_fr:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1e6',
  shortname: ':flag_ga:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1e7',
  shortname: ':flag_gb:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1e9',
  shortname: ':flag_gd:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1ea',
  shortname: ':flag_ge:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1eb',
  shortname: ':flag_gf:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1ec',
  shortname: ':flag_gg:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1ed',
  shortname: ':flag_gh:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1ee',
  shortname: ':flag_gi:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1f1',
  shortname: ':flag_gl:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1f2',
  shortname: ':flag_gm:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1f3',
  shortname: ':flag_gn:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1f5',
  shortname: ':flag_gp:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1f6',
  shortname: ':flag_gq:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1f7',
  shortname: ':flag_gr:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1f8',
  shortname: ':flag_gs:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1f9',
  shortname: ':flag_gt:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1fa',
  shortname: ':flag_gu:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1fc',
  shortname: ':flag_gw:',
  category: 'flags'
}, {
  unicode: '1f1ec-1f1fe',
  shortname: ':flag_gy:',
  category: 'flags'
}, {
  unicode: '1f1ed-1f1f0',
  shortname: ':flag_hk:',
  category: 'flags'
}, {
  unicode: '1f1ed-1f1f2',
  shortname: ':flag_hm:',
  category: 'flags'
}, {
  unicode: '1f1ed-1f1f3',
  shortname: ':flag_hn:',
  category: 'flags'
}, {
  unicode: '1f1ed-1f1f7',
  shortname: ':flag_hr:',
  category: 'flags'
}, {
  unicode: '1f1ed-1f1f9',
  shortname: ':flag_ht:',
  category: 'flags'
}, {
  unicode: '1f1ed-1f1fa',
  shortname: ':flag_hu:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1e8',
  shortname: ':flag_ic:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1e9',
  shortname: ':flag_id:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1ea',
  shortname: ':flag_ie:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1f1',
  shortname: ':flag_il:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1f2',
  shortname: ':flag_im:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1f3',
  shortname: ':flag_in:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1f4',
  shortname: ':flag_io:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1f6',
  shortname: ':flag_iq:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1f7',
  shortname: ':flag_ir:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1f8',
  shortname: ':flag_is:',
  category: 'flags'
}, {
  unicode: '1f1ee-1f1f9',
  shortname: ':flag_it:',
  category: 'flags'
}, {
  unicode: '1f1ef-1f1ea',
  shortname: ':flag_je:',
  category: 'flags'
}, {
  unicode: '1f1ef-1f1f2',
  shortname: ':flag_jm:',
  category: 'flags'
}, {
  unicode: '1f1ef-1f1f4',
  shortname: ':flag_jo:',
  category: 'flags'
}, {
  unicode: '1f1ef-1f1f5',
  shortname: ':flag_jp:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1ea',
  shortname: ':flag_ke:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1ec',
  shortname: ':flag_kg:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1ed',
  shortname: ':flag_kh:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1ee',
  shortname: ':flag_ki:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1f2',
  shortname: ':flag_km:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1f3',
  shortname: ':flag_kn:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1f5',
  shortname: ':flag_kp:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1f7',
  shortname: ':flag_kr:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1fc',
  shortname: ':flag_kw:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1fe',
  shortname: ':flag_ky:',
  category: 'flags'
}, {
  unicode: '1f1f0-1f1ff',
  shortname: ':flag_kz:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1e6',
  shortname: ':flag_la:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1e7',
  shortname: ':flag_lb:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1e8',
  shortname: ':flag_lc:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1ee',
  shortname: ':flag_li:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1f0',
  shortname: ':flag_lk:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1f7',
  shortname: ':flag_lr:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1f8',
  shortname: ':flag_ls:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1f9',
  shortname: ':flag_lt:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1fa',
  shortname: ':flag_lu:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1fb',
  shortname: ':flag_lv:',
  category: 'flags'
}, {
  unicode: '1f1f1-1f1fe',
  shortname: ':flag_ly:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1e6',
  shortname: ':flag_ma:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1e8',
  shortname: ':flag_mc:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1e9',
  shortname: ':flag_md:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1ea',
  shortname: ':flag_me:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1eb',
  shortname: ':flag_mf:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1ec',
  shortname: ':flag_mg:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1ed',
  shortname: ':flag_mh:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f0',
  shortname: ':flag_mk:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f1',
  shortname: ':flag_ml:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f2',
  shortname: ':flag_mm:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f3',
  shortname: ':flag_mn:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f4',
  shortname: ':flag_mo:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f5',
  shortname: ':flag_mp:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f6',
  shortname: ':flag_mq:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f7',
  shortname: ':flag_mr:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f8',
  shortname: ':flag_ms:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1f9',
  shortname: ':flag_mt:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1fa',
  shortname: ':flag_mu:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1fb',
  shortname: ':flag_mv:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1fc',
  shortname: ':flag_mw:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1fd',
  shortname: ':flag_mx:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1fe',
  shortname: ':flag_my:',
  category: 'flags'
}, {
  unicode: '1f1f2-1f1ff',
  shortname: ':flag_mz:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1e6',
  shortname: ':flag_na:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1e8',
  shortname: ':flag_nc:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1ea',
  shortname: ':flag_ne:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1eb',
  shortname: ':flag_nf:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1ec',
  shortname: ':flag_ng:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1ee',
  shortname: ':flag_ni:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1f1',
  shortname: ':flag_nl:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1f4',
  shortname: ':flag_no:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1f5',
  shortname: ':flag_np:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1f7',
  shortname: ':flag_nr:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1fa',
  shortname: ':flag_nu:',
  category: 'flags'
}, {
  unicode: '1f1f3-1f1ff',
  shortname: ':flag_nz:',
  category: 'flags'
}, {
  unicode: '1f1f4-1f1f2',
  shortname: ':flag_om:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1e6',
  shortname: ':flag_pa:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1ea',
  shortname: ':flag_pe:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1eb',
  shortname: ':flag_pf:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1ec',
  shortname: ':flag_pg:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1ed',
  shortname: ':flag_ph:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1f0',
  shortname: ':flag_pk:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1f1',
  shortname: ':flag_pl:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1f2',
  shortname: ':flag_pm:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1f3',
  shortname: ':flag_pn:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1f7',
  shortname: ':flag_pr:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1f8',
  shortname: ':flag_ps:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1f9',
  shortname: ':flag_pt:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1fc',
  shortname: ':flag_pw:',
  category: 'flags'
}, {
  unicode: '1f1f5-1f1fe',
  shortname: ':flag_py:',
  category: 'flags'
}, {
  unicode: '1f1f6-1f1e6',
  shortname: ':flag_qa:',
  category: 'flags'
}, {
  unicode: '1f1f7-1f1ea',
  shortname: ':flag_re:',
  category: 'flags'
}, {
  unicode: '1f1f7-1f1f4',
  shortname: ':flag_ro:',
  category: 'flags'
}, {
  unicode: '1f1f7-1f1f8',
  shortname: ':flag_rs:',
  category: 'flags'
}, {
  unicode: '1f1f7-1f1fa',
  shortname: ':flag_ru:',
  category: 'flags'
}, {
  unicode: '1f1f7-1f1fc',
  shortname: ':flag_rw:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1e6',
  shortname: ':flag_sa:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1e7',
  shortname: ':flag_sb:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1e8',
  shortname: ':flag_sc:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1e9',
  shortname: ':flag_sd:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1ea',
  shortname: ':flag_se:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1ec',
  shortname: ':flag_sg:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1ed',
  shortname: ':flag_sh:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1ee',
  shortname: ':flag_si:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1ef',
  shortname: ':flag_sj:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1f0',
  shortname: ':flag_sk:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1f1',
  shortname: ':flag_sl:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1f2',
  shortname: ':flag_sm:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1f3',
  shortname: ':flag_sn:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1f4',
  shortname: ':flag_so:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1f7',
  shortname: ':flag_sr:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1f8',
  shortname: ':flag_ss:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1f9',
  shortname: ':flag_st:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1fb',
  shortname: ':flag_sv:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1fd',
  shortname: ':flag_sx:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1fe',
  shortname: ':flag_sy:',
  category: 'flags'
}, {
  unicode: '1f1f8-1f1ff',
  shortname: ':flag_sz:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1e6',
  shortname: ':flag_ta:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1e8',
  shortname: ':flag_tc:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1e9',
  shortname: ':flag_td:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1eb',
  shortname: ':flag_tf:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1ec',
  shortname: ':flag_tg:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1ed',
  shortname: ':flag_th:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1ef',
  shortname: ':flag_tj:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1f0',
  shortname: ':flag_tk:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1f1',
  shortname: ':flag_tl:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1f2',
  shortname: ':flag_tm:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1f3',
  shortname: ':flag_tn:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1f4',
  shortname: ':flag_to:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1f7',
  shortname: ':flag_tr:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1f9',
  shortname: ':flag_tt:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1fb',
  shortname: ':flag_tv:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1fc',
  shortname: ':flag_tw:',
  category: 'flags'
}, {
  unicode: '1f1f9-1f1ff',
  shortname: ':flag_tz:',
  category: 'flags'
}, {
  unicode: '1f1fa-1f1e6',
  shortname: ':flag_ua:',
  category: 'flags'
}, {
  unicode: '1f1fa-1f1ec',
  shortname: ':flag_ug:',
  category: 'flags'
}, {
  unicode: '1f1fa-1f1f2',
  shortname: ':flag_um:',
  category: 'flags'
}, {
  unicode: '1f1fa-1f1f8',
  shortname: ':flag_us:',
  category: 'flags'
}, {
  unicode: '1f1fa-1f1fe',
  shortname: ':flag_uy:',
  category: 'flags'
}, {
  unicode: '1f1fa-1f1ff',
  shortname: ':flag_uz:',
  category: 'flags'
}, {
  unicode: '1f1fb-1f1e6',
  shortname: ':flag_va:',
  category: 'flags'
}, {
  unicode: '1f1fb-1f1e8',
  shortname: ':flag_vc:',
  category: 'flags'
}, {
  unicode: '1f1fb-1f1ea',
  shortname: ':flag_ve:',
  category: 'flags'
}, {
  unicode: '1f1fb-1f1ec',
  shortname: ':flag_vg:',
  category: 'flags'
}, {
  unicode: '1f1fb-1f1ee',
  shortname: ':flag_vi:',
  category: 'flags'
}, {
  unicode: '1f1fb-1f1f3',
  shortname: ':flag_vn:',
  category: 'flags'
}, {
  unicode: '1f1fb-1f1fa',
  shortname: ':flag_vu:',
  category: 'flags'
}, {
  unicode: '1f1fc-1f1eb',
  shortname: ':flag_wf:',
  category: 'flags'
}, {
  unicode: '1f1fc-1f1f8',
  shortname: ':flag_ws:',
  category: 'flags'
}, {
  unicode: '1f1fd-1f1f0',
  shortname: ':flag_xk:',
  category: 'flags'
}, {
  unicode: '1f1fe-1f1ea',
  shortname: ':flag_ye:',
  category: 'flags'
}, {
  unicode: '1f1fe-1f1f9',
  shortname: ':flag_yt:',
  category: 'flags'
}, {
  unicode: '1f1ff-1f1e6',
  shortname: ':flag_za:',
  category: 'flags'
}, {
  unicode: '1f1ff-1f1f2',
  shortname: ':flag_zm:',
  category: 'flags'
}, {
  unicode: '1f1ff-1f1fc',
  shortname: ':flag_zw:',
  category: 'flags'
}, {
  unicode: '1f347',
  shortname: ':grapes:',
  category: 'food'
}, {
  unicode: '1f348',
  shortname: ':melon:',
  category: 'food'
}, {
  unicode: '1f349',
  shortname: ':watermelon:',
  category: 'food'
}, {
  unicode: '1f34a',
  shortname: ':tangerine:',
  category: 'food'
}, {
  unicode: '1f34b',
  shortname: ':lemon:',
  category: 'food'
}, {
  unicode: '1f34c',
  shortname: ':banana:',
  category: 'food'
}, {
  unicode: '1f34d',
  shortname: ':pineapple:',
  category: 'food'
}, {
  unicode: '1f34e',
  shortname: ':apple:',
  category: 'food'
}, {
  unicode: '1f34f',
  shortname: ':green_apple:',
  category: 'food'
}, {
  unicode: '1f350',
  shortname: ':pear:',
  category: 'food'
}, {
  unicode: '1f351',
  shortname: ':peach:',
  category: 'food'
}, {
  unicode: '1f352',
  shortname: ':cherries:',
  category: 'food'
}, {
  unicode: '1f353',
  shortname: ':strawberry:',
  category: 'food'
}, {
  unicode: '1f95d',
  shortname: ':kiwi:',
  category: 'food'
}, {
  unicode: '1f345',
  shortname: ':tomato:',
  category: 'food'
}, {
  unicode: '1f951',
  shortname: ':avocado:',
  category: 'food'
}, {
  unicode: '1f346',
  shortname: ':eggplant:',
  category: 'food'
}, {
  unicode: '1f954',
  shortname: ':potato:',
  category: 'food'
}, {
  unicode: '1f955',
  shortname: ':carrot:',
  category: 'food'
}, {
  unicode: '1f33d',
  shortname: ':corn:',
  category: 'food'
}, {
  unicode: '1f336',
  shortname: ':hot_pepper:',
  category: 'food'
}, {
  unicode: '1f952',
  shortname: ':cucumber:',
  category: 'food'
}, {
  unicode: '1f95c',
  shortname: ':peanuts:',
  category: 'food'
}, {
  unicode: '1f35e',
  shortname: ':bread:',
  category: 'food'
}, {
  unicode: '1f950',
  shortname: ':croissant:',
  category: 'food'
}, {
  unicode: '1f956',
  shortname: ':french_bread:',
  category: 'food'
}, {
  unicode: '1f95e',
  shortname: ':pancakes:',
  category: 'food'
}, {
  unicode: '1f9c0',
  shortname: ':cheese:',
  category: 'food'
}, {
  unicode: '1f356',
  shortname: ':meat_on_bone:',
  category: 'food'
}, {
  unicode: '1f357',
  shortname: ':poultry_leg:',
  category: 'food'
}, {
  unicode: '1f953',
  shortname: ':bacon:',
  category: 'food'
}, {
  unicode: '1f354',
  shortname: ':hamburger:',
  category: 'food'
}, {
  unicode: '1f35f',
  shortname: ':fries:',
  category: 'food'
}, {
  unicode: '1f355',
  shortname: ':pizza:',
  category: 'food'
}, {
  unicode: '1f32d',
  shortname: ':hotdog:',
  category: 'food'
}, {
  unicode: '1f32e',
  shortname: ':taco:',
  category: 'food'
}, {
  unicode: '1f32f',
  shortname: ':burrito:',
  category: 'food'
}, {
  unicode: '1f959',
  shortname: ':stuffed_flatbread:',
  category: 'food'
}, {
  unicode: '1f95a',
  shortname: ':egg:',
  category: 'food'
}, {
  unicode: '1f373',
  shortname: ':cooking:',
  category: 'food'
}, {
  unicode: '1f958',
  shortname: ':shallow_pan_of_food:',
  category: 'food'
}, {
  unicode: '1f372',
  shortname: ':stew:',
  category: 'food'
}, {
  unicode: '1f957',
  shortname: ':salad:',
  category: 'food'
}, {
  unicode: '1f37f',
  shortname: ':popcorn:',
  category: 'food'
}, {
  unicode: '1f371',
  shortname: ':bento:',
  category: 'food'
}, {
  unicode: '1f358',
  shortname: ':rice_cracker:',
  category: 'food'
}, {
  unicode: '1f359',
  shortname: ':rice_ball:',
  category: 'food'
}, {
  unicode: '1f35a',
  shortname: ':rice:',
  category: 'food'
}, {
  unicode: '1f35b',
  shortname: ':curry:',
  category: 'food'
}, {
  unicode: '1f35c',
  shortname: ':ramen:',
  category: 'food'
}, {
  unicode: '1f35d',
  shortname: ':spaghetti:',
  category: 'food'
}, {
  unicode: '1f360',
  shortname: ':sweet_potato:',
  category: 'food'
}, {
  unicode: '1f362',
  shortname: ':oden:',
  category: 'food'
}, {
  unicode: '1f363',
  shortname: ':sushi:',
  category: 'food'
}, {
  unicode: '1f364',
  shortname: ':fried_shrimp:',
  category: 'food'
}, {
  unicode: '1f365',
  shortname: ':fish_cake:',
  category: 'food'
}, {
  unicode: '1f361',
  shortname: ':dango:',
  category: 'food'
}, {
  unicode: '1f366',
  shortname: ':icecream:',
  category: 'food'
}, {
  unicode: '1f367',
  shortname: ':shaved_ice:',
  category: 'food'
}, {
  unicode: '1f368',
  shortname: ':ice_cream:',
  category: 'food'
}, {
  unicode: '1f369',
  shortname: ':doughnut:',
  category: 'food'
}, {
  unicode: '1f36a',
  shortname: ':cookie:',
  category: 'food'
}, {
  unicode: '1f382',
  shortname: ':birthday:',
  category: 'food'
}, {
  unicode: '1f370',
  shortname: ':cake:',
  category: 'food'
}, {
  unicode: '1f36b',
  shortname: ':chocolate_bar:',
  category: 'food'
}, {
  unicode: '1f36c',
  shortname: ':candy:',
  category: 'food'
}, {
  unicode: '1f36d',
  shortname: ':lollipop:',
  category: 'food'
}, {
  unicode: '1f36e',
  shortname: ':custard:',
  category: 'food'
}, {
  unicode: '1f36f',
  shortname: ':honey_pot:',
  category: 'food'
}, {
  unicode: '1f37c',
  shortname: ':baby_bottle:',
  category: 'food'
}, {
  unicode: '1f95b',
  shortname: ':milk:',
  category: 'food'
}, {
  unicode: '2615',
  shortname: ':coffee:',
  category: 'food'
}, {
  unicode: '1f375',
  shortname: ':tea:',
  category: 'food'
}, {
  unicode: '1f376',
  shortname: ':sake:',
  category: 'food'
}, {
  unicode: '1f37e',
  shortname: ':champagne:',
  category: 'food'
}, {
  unicode: '1f377',
  shortname: ':wine_glass:',
  category: 'food'
}, {
  unicode: '1f378',
  shortname: ':cocktail:',
  category: 'food'
}, {
  unicode: '1f379',
  shortname: ':tropical_drink:',
  category: 'food'
}, {
  unicode: '1f37a',
  shortname: ':beer:',
  category: 'food'
}, {
  unicode: '1f37b',
  shortname: ':beers:',
  category: 'food'
}, {
  unicode: '1f942',
  shortname: ':champagne_glass:',
  category: 'food'
}, {
  unicode: '1f943',
  shortname: ':tumbler_glass:',
  category: 'food'
}, {
  unicode: '1f37d',
  shortname: ':fork_knife_plate:',
  category: 'food'
}, {
  unicode: '1f374',
  shortname: ':fork_and_knife:',
  category: 'food'
}, {
  unicode: '1f944',
  shortname: ':spoon:',
  category: 'food'
}, {
  unicode: '1f3fb',
  shortname: ':tone1:',
  category: 'modifier'
}, {
  unicode: '1f3fc',
  shortname: ':tone2:',
  category: 'modifier'
}, {
  unicode: '1f3fd',
  shortname: ':tone3:',
  category: 'modifier'
}, {
  unicode: '1f3fe',
  shortname: ':tone4:',
  category: 'modifier'
}, {
  unicode: '1f3ff',
  shortname: ':tone5:',
  category: 'modifier'
}, {
  unicode: '1f648',
  shortname: ':see_no_evil:',
  category: 'nature'
}, {
  unicode: '1f649',
  shortname: ':hear_no_evil:',
  category: 'nature'
}, {
  unicode: '1f64a',
  shortname: ':speak_no_evil:',
  category: 'nature'
}, {
  unicode: '1f4a6',
  shortname: ':sweat_drops:',
  category: 'nature'
}, {
  unicode: '1f4a8',
  shortname: ':dash:',
  category: 'nature'
}, {
  unicode: '1f435',
  shortname: ':monkey_face:',
  category: 'nature'
}, {
  unicode: '1f412',
  shortname: ':monkey:',
  category: 'nature'
}, {
  unicode: '1f98d',
  shortname: ':gorilla:',
  category: 'nature'
}, {
  unicode: '1f436',
  shortname: ':dog:',
  category: 'nature'
}, {
  unicode: '1f415',
  shortname: ':dog2:',
  category: 'nature'
}, {
  unicode: '1f429',
  shortname: ':poodle:',
  category: 'nature'
}, {
  unicode: '1f43a',
  shortname: ':wolf:',
  category: 'nature'
}, {
  unicode: '1f98a',
  shortname: ':fox:',
  category: 'nature'
}, {
  unicode: '1f431',
  shortname: ':cat:',
  category: 'nature'
}, {
  unicode: '1f408',
  shortname: ':cat2:',
  category: 'nature'
}, {
  unicode: '1f981',
  shortname: ':lion_face:',
  category: 'nature'
}, {
  unicode: '1f42f',
  shortname: ':tiger:',
  category: 'nature'
}, {
  unicode: '1f405',
  shortname: ':tiger2:',
  category: 'nature'
}, {
  unicode: '1f406',
  shortname: ':leopard:',
  category: 'nature'
}, {
  unicode: '1f434',
  shortname: ':horse:',
  category: 'nature'
}, {
  unicode: '1f40e',
  shortname: ':racehorse:',
  category: 'nature'
}, {
  unicode: '1f98c',
  shortname: ':deer:',
  category: 'nature'
}, {
  unicode: '1f984',
  shortname: ':unicorn:',
  category: 'nature'
}, {
  unicode: '1f42e',
  shortname: ':cow:',
  category: 'nature'
}, {
  unicode: '1f402',
  shortname: ':ox:',
  category: 'nature'
}, {
  unicode: '1f403',
  shortname: ':water_buffalo:',
  category: 'nature'
}, {
  unicode: '1f404',
  shortname: ':cow2:',
  category: 'nature'
}, {
  unicode: '1f437',
  shortname: ':pig:',
  category: 'nature'
}, {
  unicode: '1f416',
  shortname: ':pig2:',
  category: 'nature'
}, {
  unicode: '1f417',
  shortname: ':boar:',
  category: 'nature'
}, {
  unicode: '1f43d',
  shortname: ':pig_nose:',
  category: 'nature'
}, {
  unicode: '1f40f',
  shortname: ':ram:',
  category: 'nature'
}, {
  unicode: '1f411',
  shortname: ':sheep:',
  category: 'nature'
}, {
  unicode: '1f410',
  shortname: ':goat:',
  category: 'nature'
}, {
  unicode: '1f42a',
  shortname: ':dromedary_camel:',
  category: 'nature'
}, {
  unicode: '1f42b',
  shortname: ':camel:',
  category: 'nature'
}, {
  unicode: '1f418',
  shortname: ':elephant:',
  category: 'nature'
}, {
  unicode: '1f98f',
  shortname: ':rhino:',
  category: 'nature'
}, {
  unicode: '1f42d',
  shortname: ':mouse:',
  category: 'nature'
}, {
  unicode: '1f401',
  shortname: ':mouse2:',
  category: 'nature'
}, {
  unicode: '1f400',
  shortname: ':rat:',
  category: 'nature'
}, {
  unicode: '1f439',
  shortname: ':hamster:',
  category: 'nature'
}, {
  unicode: '1f430',
  shortname: ':rabbit:',
  category: 'nature'
}, {
  unicode: '1f407',
  shortname: ':rabbit2:',
  category: 'nature'
}, {
  unicode: '1f43f',
  shortname: ':chipmunk:',
  category: 'nature'
}, {
  unicode: '1f987',
  shortname: ':bat:',
  category: 'nature'
}, {
  unicode: '1f43b',
  shortname: ':bear:',
  category: 'nature'
}, {
  unicode: '1f428',
  shortname: ':koala:',
  category: 'nature'
}, {
  unicode: '1f43c',
  shortname: ':panda_face:',
  category: 'nature'
}, {
  unicode: '1f43e',
  shortname: ':feet:',
  category: 'nature'
}, {
  unicode: '1f983',
  shortname: ':turkey:',
  category: 'nature'
}, {
  unicode: '1f414',
  shortname: ':chicken:',
  category: 'nature'
}, {
  unicode: '1f413',
  shortname: ':rooster:',
  category: 'nature'
}, {
  unicode: '1f423',
  shortname: ':hatching_chick:',
  category: 'nature'
}, {
  unicode: '1f424',
  shortname: ':baby_chick:',
  category: 'nature'
}, {
  unicode: '1f425',
  shortname: ':hatched_chick:',
  category: 'nature'
}, {
  unicode: '1f426',
  shortname: ':bird:',
  category: 'nature'
}, {
  unicode: '1f427',
  shortname: ':penguin:',
  category: 'nature'
}, {
  unicode: '1f54a',
  shortname: ':dove:',
  category: 'nature'
}, {
  unicode: '1f985',
  shortname: ':eagle:',
  category: 'nature'
}, {
  unicode: '1f986',
  shortname: ':duck:',
  category: 'nature'
}, {
  unicode: '1f989',
  shortname: ':owl:',
  category: 'nature'
}, {
  unicode: '1f438',
  shortname: ':frog:',
  category: 'nature'
}, {
  unicode: '1f40a',
  shortname: ':crocodile:',
  category: 'nature'
}, {
  unicode: '1f422',
  shortname: ':turtle:',
  category: 'nature'
}, {
  unicode: '1f98e',
  shortname: ':lizard:',
  category: 'nature'
}, {
  unicode: '1f40d',
  shortname: ':snake:',
  category: 'nature'
}, {
  unicode: '1f432',
  shortname: ':dragon_face:',
  category: 'nature'
}, {
  unicode: '1f409',
  shortname: ':dragon:',
  category: 'nature'
}, {
  unicode: '1f433',
  shortname: ':whale:',
  category: 'nature'
}, {
  unicode: '1f40b',
  shortname: ':whale2:',
  category: 'nature'
}, {
  unicode: '1f42c',
  shortname: ':dolphin:',
  category: 'nature'
}, {
  unicode: '1f41f',
  shortname: ':fish:',
  category: 'nature'
}, {
  unicode: '1f420',
  shortname: ':tropical_fish:',
  category: 'nature'
}, {
  unicode: '1f421',
  shortname: ':blowfish:',
  category: 'nature'
}, {
  unicode: '1f988',
  shortname: ':shark:',
  category: 'nature'
}, {
  unicode: '1f419',
  shortname: ':octopus:',
  category: 'nature'
}, {
  unicode: '1f41a',
  shortname: ':shell:',
  category: 'nature'
}, {
  unicode: '1f980',
  shortname: ':crab:',
  category: 'nature'
}, {
  unicode: '1f990',
  shortname: ':shrimp:',
  category: 'nature'
}, {
  unicode: '1f991',
  shortname: ':squid:',
  category: 'nature'
}, {
  unicode: '1f98b',
  shortname: ':butterfly:',
  category: 'nature'
}, {
  unicode: '1f40c',
  shortname: ':snail:',
  category: 'nature'
}, {
  unicode: '1f41b',
  shortname: ':bug:',
  category: 'nature'
}, {
  unicode: '1f41c',
  shortname: ':ant:',
  category: 'nature'
}, {
  unicode: '1f41d',
  shortname: ':bee:',
  category: 'nature'
}, {
  unicode: '1f41e',
  shortname: ':beetle:',
  category: 'nature'
}, {
  unicode: '1f577',
  shortname: ':spider:',
  category: 'nature'
}, {
  unicode: '1f578',
  shortname: ':spider_web:',
  category: 'nature'
}, {
  unicode: '1f982',
  shortname: ':scorpion:',
  category: 'nature'
}, {
  unicode: '1f490',
  shortname: ':bouquet:',
  category: 'nature'
}, {
  unicode: '1f338',
  shortname: ':cherry_blossom:',
  category: 'nature'
}, {
  unicode: '1f3f5',
  shortname: ':rosette:',
  category: 'nature'
}, {
  unicode: '1f339',
  shortname: ':rose:',
  category: 'nature'
}, {
  unicode: '1f940',
  shortname: ':wilted_rose:',
  category: 'nature'
}, {
  unicode: '1f33a',
  shortname: ':hibiscus:',
  category: 'nature'
}, {
  unicode: '1f33b',
  shortname: ':sunflower:',
  category: 'nature'
}, {
  unicode: '1f33c',
  shortname: ':blossom:',
  category: 'nature'
}, {
  unicode: '1f337',
  shortname: ':tulip:',
  category: 'nature'
}, {
  unicode: '1f331',
  shortname: ':seedling:',
  category: 'nature'
}, {
  unicode: '1f332',
  shortname: ':evergreen_tree:',
  category: 'nature'
}, {
  unicode: '1f333',
  shortname: ':deciduous_tree:',
  category: 'nature'
}, {
  unicode: '1f334',
  shortname: ':palm_tree:',
  category: 'nature'
}, {
  unicode: '1f335',
  shortname: ':cactus:',
  category: 'nature'
}, {
  unicode: '1f33e',
  shortname: ':ear_of_rice:',
  category: 'nature'
}, {
  unicode: '1f33f',
  shortname: ':herb:',
  category: 'nature'
}, {
  unicode: '2618',
  shortname: ':shamrock:',
  category: 'nature'
}, {
  unicode: '1f340',
  shortname: ':four_leaf_clover:',
  category: 'nature'
}, {
  unicode: '1f341',
  shortname: ':maple_leaf:',
  category: 'nature'
}, {
  unicode: '1f342',
  shortname: ':fallen_leaf:',
  category: 'nature'
}, {
  unicode: '1f343',
  shortname: ':leaves:',
  category: 'nature'
}, {
  unicode: '1f344',
  shortname: ':mushroom:',
  category: 'nature'
}, {
  unicode: '1f330',
  shortname: ':chestnut:',
  category: 'nature'
}, {
  unicode: '1f30d',
  shortname: ':earth_africa:',
  category: 'nature'
}, {
  unicode: '1f30e',
  shortname: ':earth_americas:',
  category: 'nature'
}, {
  unicode: '1f30f',
  shortname: ':earth_asia:',
  category: 'nature'
}, {
  unicode: '1f311',
  shortname: ':new_moon:',
  category: 'nature'
}, {
  unicode: '1f312',
  shortname: ':waxing_crescent_moon:',
  category: 'nature'
}, {
  unicode: '1f313',
  shortname: ':first_quarter_moon:',
  category: 'nature'
}, {
  unicode: '1f314',
  shortname: ':waxing_gibbous_moon:',
  category: 'nature'
}, {
  unicode: '1f315',
  shortname: ':full_moon:',
  category: 'nature'
}, {
  unicode: '1f316',
  shortname: ':waning_gibbous_moon:',
  category: 'nature'
}, {
  unicode: '1f317',
  shortname: ':last_quarter_moon:',
  category: 'nature'
}, {
  unicode: '1f318',
  shortname: ':waning_crescent_moon:',
  category: 'nature'
}, {
  unicode: '1f319',
  shortname: ':crescent_moon:',
  category: 'nature'
}, {
  unicode: '1f31a',
  shortname: ':new_moon_with_face:',
  category: 'nature'
}, {
  unicode: '1f31b',
  shortname: ':first_quarter_moon_with_face:',
  category: 'nature'
}, {
  unicode: '1f31c',
  shortname: ':last_quarter_moon_with_face:',
  category: 'nature'
}, {
  unicode: '2600',
  shortname: ':sunny:',
  category: 'nature'
}, {
  unicode: '1f31d',
  shortname: ':full_moon_with_face:',
  category: 'nature'
}, {
  unicode: '1f31e',
  shortname: ':sun_with_face:',
  category: 'nature'
}, {
  unicode: '2b50',
  shortname: ':star:',
  category: 'nature'
}, {
  unicode: '1f31f',
  shortname: ':star2:',
  category: 'nature'
}, {
  unicode: '2601',
  shortname: ':cloud:',
  category: 'nature'
}, {
  unicode: '26c5',
  shortname: ':partly_sunny:',
  category: 'nature'
}, {
  unicode: '26c8',
  shortname: ':thunder_cloud_rain:',
  category: 'nature'
}, {
  unicode: '1f324',
  shortname: ':white_sun_small_cloud:',
  category: 'nature'
}, {
  unicode: '1f325',
  shortname: ':white_sun_cloud:',
  category: 'nature'
}, {
  unicode: '1f326',
  shortname: ':white_sun_rain_cloud:',
  category: 'nature'
}, {
  unicode: '1f327',
  shortname: ':cloud_rain:',
  category: 'nature'
}, {
  unicode: '1f328',
  shortname: ':cloud_snow:',
  category: 'nature'
}, {
  unicode: '1f329',
  shortname: ':cloud_lightning:',
  category: 'nature'
}, {
  unicode: '1f32a',
  shortname: ':cloud_tornado:',
  category: 'nature'
}, {
  unicode: '1f32b',
  shortname: ':fog:',
  category: 'nature'
}, {
  unicode: '1f32c',
  shortname: ':wind_blowing_face:',
  category: 'nature'
}, {
  unicode: '2602',
  shortname: ':umbrella2:',
  category: 'nature'
}, {
  unicode: '2614',
  shortname: ':umbrella:',
  category: 'nature'
}, {
  unicode: '26a1',
  shortname: ':zap:',
  category: 'nature'
}, {
  unicode: '2744',
  shortname: ':snowflake:',
  category: 'nature'
}, {
  unicode: '2603',
  shortname: ':snowman2:',
  category: 'nature'
}, {
  unicode: '26c4',
  shortname: ':snowman:',
  category: 'nature'
}, {
  unicode: '2604',
  shortname: ':comet:',
  category: 'nature'
}, {
  unicode: '1f525',
  shortname: ':fire:',
  category: 'nature'
}, {
  unicode: '1f4a7',
  shortname: ':droplet:',
  category: 'nature'
}, {
  unicode: '1f30a',
  shortname: ':ocean:',
  category: 'nature'
}, {
  unicode: '1f383',
  shortname: ':jack_o_lantern:',
  category: 'nature'
}, {
  unicode: '1f384',
  shortname: ':christmas_tree:',
  category: 'nature'
}, {
  unicode: '2728',
  shortname: ':sparkles:',
  category: 'nature'
}, {
  unicode: '1f38b',
  shortname: ':tanabata_tree:',
  category: 'nature'
}, {
  unicode: '1f38d',
  shortname: ':bamboo:',
  category: 'nature'
}, {
  unicode: '2620',
  shortname: ':skull_crossbones:',
  category: 'objects'
}, {
  unicode: '1f48c',
  shortname: ':love_letter:',
  category: 'objects'
}, {
  unicode: '1f4a3',
  shortname: ':bomb:',
  category: 'objects'
}, {
  unicode: '1f573',
  shortname: ':hole:',
  category: 'objects'
}, {
  unicode: '1f6cd',
  shortname: ':shopping_bags:',
  category: 'objects'
}, {
  unicode: '1f4ff',
  shortname: ':prayer_beads:',
  category: 'objects'
}, {
  unicode: '1f48e',
  shortname: ':gem:',
  category: 'objects'
}, {
  unicode: '1f52a',
  shortname: ':knife:',
  category: 'objects'
}, {
  unicode: '1f3fa',
  shortname: ':amphora:',
  category: 'objects'
}, {
  unicode: '1f5fa',
  shortname: ':map:',
  category: 'objects'
}, {
  unicode: '1f488',
  shortname: ':barber:',
  category: 'objects'
}, {
  unicode: '1f5bc',
  shortname: ':frame_photo:',
  category: 'objects'
}, {
  unicode: '1f6ce',
  shortname: ':bellhop:',
  category: 'objects'
}, {
  unicode: '1f6aa',
  shortname: ':door:',
  category: 'objects'
}, {
  unicode: '1f6cc',
  shortname: ':sleeping_accommodation:',
  category: 'objects'
}, {
  unicode: '1f6cf',
  shortname: ':bed:',
  category: 'objects'
}, {
  unicode: '1f6cb',
  shortname: ':couch:',
  category: 'objects'
}, {
  unicode: '1f6bd',
  shortname: ':toilet:',
  category: 'objects'
}, {
  unicode: '1f6bf',
  shortname: ':shower:',
  category: 'objects'
}, {
  unicode: '1f6c1',
  shortname: ':bathtub:',
  category: 'objects'
}, {
  unicode: '231b',
  shortname: ':hourglass:',
  category: 'objects'
}, {
  unicode: '23f3',
  shortname: ':hourglass_flowing_sand:',
  category: 'objects'
}, {
  unicode: '231a',
  shortname: ':watch:',
  category: 'objects'
}, {
  unicode: '23f0',
  shortname: ':alarm_clock:',
  category: 'objects'
}, {
  unicode: '23f1',
  shortname: ':stopwatch:',
  category: 'objects'
}, {
  unicode: '23f2',
  shortname: ':timer:',
  category: 'objects'
}, {
  unicode: '1f570',
  shortname: ':clock:',
  category: 'objects'
}, {
  unicode: '1f321',
  shortname: ':thermometer:',
  category: 'objects'
}, {
  unicode: '26f1',
  shortname: ':beach_umbrella:',
  category: 'objects'
}, {
  unicode: '1f388',
  shortname: ':balloon:',
  category: 'objects'
}, {
  unicode: '1f389',
  shortname: ':tada:',
  category: 'objects'
}, {
  unicode: '1f38a',
  shortname: ':confetti_ball:',
  category: 'objects'
}, {
  unicode: '1f38e',
  shortname: ':dolls:',
  category: 'objects'
}, {
  unicode: '1f38f',
  shortname: ':flags:',
  category: 'objects'
}, {
  unicode: '1f390',
  shortname: ':wind_chime:',
  category: 'objects'
}, {
  unicode: '1f380',
  shortname: ':ribbon:',
  category: 'objects'
}, {
  unicode: '1f381',
  shortname: ':gift:',
  category: 'objects'
}, {
  unicode: '1f579',
  shortname: ':joystick:',
  category: 'objects'
}, {
  unicode: '1f4ef',
  shortname: ':postal_horn:',
  category: 'objects'
}, {
  unicode: '1f399',
  shortname: ':microphone2:',
  category: 'objects'
}, {
  unicode: '1f39a',
  shortname: ':level_slider:',
  category: 'objects'
}, {
  unicode: '1f39b',
  shortname: ':control_knobs:',
  category: 'objects'
}, {
  unicode: '1f4fb',
  shortname: ':radio:',
  category: 'objects'
}, {
  unicode: '1f4f1',
  shortname: ':iphone:',
  category: 'objects'
}, {
  unicode: '1f4f2',
  shortname: ':calling:',
  category: 'objects'
}, {
  unicode: '260e',
  shortname: ':telephone:',
  category: 'objects'
}, {
  unicode: '1f4de',
  shortname: ':telephone_receiver:',
  category: 'objects'
}, {
  unicode: '1f4df',
  shortname: ':pager:',
  category: 'objects'
}, {
  unicode: '1f4e0',
  shortname: ':fax:',
  category: 'objects'
}, {
  unicode: '1f50b',
  shortname: ':battery:',
  category: 'objects'
}, {
  unicode: '1f50c',
  shortname: ':electric_plug:',
  category: 'objects'
}, {
  unicode: '1f4bb',
  shortname: ':computer:',
  category: 'objects'
}, {
  unicode: '1f5a5',
  shortname: ':desktop:',
  category: 'objects'
}, {
  unicode: '1f5a8',
  shortname: ':printer:',
  category: 'objects'
}, {
  unicode: '2328',
  shortname: ':keyboard:',
  category: 'objects'
}, {
  unicode: '1f5b1',
  shortname: ':mouse_three_button:',
  category: 'objects'
}, {
  unicode: '1f5b2',
  shortname: ':trackball:',
  category: 'objects'
}, {
  unicode: '1f4bd',
  shortname: ':minidisc:',
  category: 'objects'
}, {
  unicode: '1f4be',
  shortname: ':floppy_disk:',
  category: 'objects'
}, {
  unicode: '1f4bf',
  shortname: ':cd:',
  category: 'objects'
}, {
  unicode: '1f4c0',
  shortname: ':dvd:',
  category: 'objects'
}, {
  unicode: '1f3a5',
  shortname: ':movie_camera:',
  category: 'objects'
}, {
  unicode: '1f39e',
  shortname: ':film_frames:',
  category: 'objects'
}, {
  unicode: '1f4fd',
  shortname: ':projector:',
  category: 'objects'
}, {
  unicode: '1f4fa',
  shortname: ':tv:',
  category: 'objects'
}, {
  unicode: '1f4f7',
  shortname: ':camera:',
  category: 'objects'
}, {
  unicode: '1f4f8',
  shortname: ':camera_with_flash:',
  category: 'objects'
}, {
  unicode: '1f4f9',
  shortname: ':video_camera:',
  category: 'objects'
}, {
  unicode: '1f4fc',
  shortname: ':vhs:',
  category: 'objects'
}, {
  unicode: '1f50d',
  shortname: ':mag:',
  category: 'objects'
}, {
  unicode: '1f50e',
  shortname: ':mag_right:',
  category: 'objects'
}, {
  unicode: '1f52c',
  shortname: ':microscope:',
  category: 'objects'
}, {
  unicode: '1f52d',
  shortname: ':telescope:',
  category: 'objects'
}, {
  unicode: '1f4e1',
  shortname: ':satellite:',
  category: 'objects'
}, {
  unicode: '1f56f',
  shortname: ':candle:',
  category: 'objects'
}, {
  unicode: '1f4a1',
  shortname: ':bulb:',
  category: 'objects'
}, {
  unicode: '1f526',
  shortname: ':flashlight:',
  category: 'objects'
}, {
  unicode: '1f3ee',
  shortname: ':izakaya_lantern:',
  category: 'objects'
}, {
  unicode: '1f4d4',
  shortname: ':notebook_with_decorative_cover:',
  category: 'objects'
}, {
  unicode: '1f4d5',
  shortname: ':closed_book:',
  category: 'objects'
}, {
  unicode: '1f4d6',
  shortname: ':book:',
  category: 'objects'
}, {
  unicode: '1f4d7',
  shortname: ':green_book:',
  category: 'objects'
}, {
  unicode: '1f4d8',
  shortname: ':blue_book:',
  category: 'objects'
}, {
  unicode: '1f4d9',
  shortname: ':orange_book:',
  category: 'objects'
}, {
  unicode: '1f4da',
  shortname: ':books:',
  category: 'objects'
}, {
  unicode: '1f4d3',
  shortname: ':notebook:',
  category: 'objects'
}, {
  unicode: '1f4d2',
  shortname: ':ledger:',
  category: 'objects'
}, {
  unicode: '1f4c3',
  shortname: ':page_with_curl:',
  category: 'objects'
}, {
  unicode: '1f4dc',
  shortname: ':scroll:',
  category: 'objects'
}, {
  unicode: '1f4c4',
  shortname: ':page_facing_up:',
  category: 'objects'
}, {
  unicode: '1f4f0',
  shortname: ':newspaper:',
  category: 'objects'
}, {
  unicode: '1f5de',
  shortname: ':newspaper2:',
  category: 'objects'
}, {
  unicode: '1f4d1',
  shortname: ':bookmark_tabs:',
  category: 'objects'
}, {
  unicode: '1f516',
  shortname: ':bookmark:',
  category: 'objects'
}, {
  unicode: '1f3f7',
  shortname: ':label:',
  category: 'objects'
}, {
  unicode: '1f4b0',
  shortname: ':moneybag:',
  category: 'objects'
}, {
  unicode: '1f4b4',
  shortname: ':yen:',
  category: 'objects'
}, {
  unicode: '1f4b5',
  shortname: ':dollar:',
  category: 'objects'
}, {
  unicode: '1f4b6',
  shortname: ':euro:',
  category: 'objects'
}, {
  unicode: '1f4b7',
  shortname: ':pound:',
  category: 'objects'
}, {
  unicode: '1f4b8',
  shortname: ':money_with_wings:',
  category: 'objects'
}, {
  unicode: '1f4b3',
  shortname: ':credit_card:',
  category: 'objects'
}, {
  unicode: '2709',
  shortname: ':envelope:',
  category: 'objects'
}, {
  unicode: '1f4e7',
  shortname: ':e-mail:',
  category: 'objects'
}, {
  unicode: '1f4e8',
  shortname: ':incoming_envelope:',
  category: 'objects'
}, {
  unicode: '1f4e9',
  shortname: ':envelope_with_arrow:',
  category: 'objects'
}, {
  unicode: '1f4e4',
  shortname: ':outbox_tray:',
  category: 'objects'
}, {
  unicode: '1f4e5',
  shortname: ':inbox_tray:',
  category: 'objects'
}, {
  unicode: '1f4e6',
  shortname: ':package:',
  category: 'objects'
}, {
  unicode: '1f4eb',
  shortname: ':mailbox:',
  category: 'objects'
}, {
  unicode: '1f4ea',
  shortname: ':mailbox_closed:',
  category: 'objects'
}, {
  unicode: '1f4ec',
  shortname: ':mailbox_with_mail:',
  category: 'objects'
}, {
  unicode: '1f4ed',
  shortname: ':mailbox_with_no_mail:',
  category: 'objects'
}, {
  unicode: '1f4ee',
  shortname: ':postbox:',
  category: 'objects'
}, {
  unicode: '1f5f3',
  shortname: ':ballot_box:',
  category: 'objects'
}, {
  unicode: '270f',
  shortname: ':pencil2:',
  category: 'objects'
}, {
  unicode: '2712',
  shortname: ':black_nib:',
  category: 'objects'
}, {
  unicode: '1f58b',
  shortname: ':pen_fountain:',
  category: 'objects'
}, {
  unicode: '1f58a',
  shortname: ':pen_ballpoint:',
  category: 'objects'
}, {
  unicode: '1f58c',
  shortname: ':paintbrush:',
  category: 'objects'
}, {
  unicode: '1f58d',
  shortname: ':crayon:',
  category: 'objects'
}, {
  unicode: '1f4dd',
  shortname: ':pencil:',
  category: 'objects'
}, {
  unicode: '1f4c1',
  shortname: ':file_folder:',
  category: 'objects'
}, {
  unicode: '1f4c2',
  shortname: ':open_file_folder:',
  category: 'objects'
}, {
  unicode: '1f5c2',
  shortname: ':dividers:',
  category: 'objects'
}, {
  unicode: '1f4c5',
  shortname: ':date:',
  category: 'objects'
}, {
  unicode: '1f4c6',
  shortname: ':calendar:',
  category: 'objects'
}, {
  unicode: '1f5d2',
  shortname: ':notepad_spiral:',
  category: 'objects'
}, {
  unicode: '1f5d3',
  shortname: ':calendar_spiral:',
  category: 'objects'
}, {
  unicode: '1f4c7',
  shortname: ':card_index:',
  category: 'objects'
}, {
  unicode: '1f4c8',
  shortname: ':chart_with_upwards_trend:',
  category: 'objects'
}, {
  unicode: '1f4c9',
  shortname: ':chart_with_downwards_trend:',
  category: 'objects'
}, {
  unicode: '1f4ca',
  shortname: ':bar_chart:',
  category: 'objects'
}, {
  unicode: '1f4cb',
  shortname: ':clipboard:',
  category: 'objects'
}, {
  unicode: '1f4cc',
  shortname: ':pushpin:',
  category: 'objects'
}, {
  unicode: '1f4cd',
  shortname: ':round_pushpin:',
  category: 'objects'
}, {
  unicode: '1f4ce',
  shortname: ':paperclip:',
  category: 'objects'
}, {
  unicode: '1f587',
  shortname: ':paperclips:',
  category: 'objects'
}, {
  unicode: '1f4cf',
  shortname: ':straight_ruler:',
  category: 'objects'
}, {
  unicode: '1f4d0',
  shortname: ':triangular_ruler:',
  category: 'objects'
}, {
  unicode: '2702',
  shortname: ':scissors:',
  category: 'objects'
}, {
  unicode: '1f5c3',
  shortname: ':card_box:',
  category: 'objects'
}, {
  unicode: '1f5c4',
  shortname: ':file_cabinet:',
  category: 'objects'
}, {
  unicode: '1f5d1',
  shortname: ':wastebasket:',
  category: 'objects'
}, {
  unicode: '1f512',
  shortname: ':lock:',
  category: 'objects'
}, {
  unicode: '1f513',
  shortname: ':unlock:',
  category: 'objects'
}, {
  unicode: '1f50f',
  shortname: ':lock_with_ink_pen:',
  category: 'objects'
}, {
  unicode: '1f510',
  shortname: ':closed_lock_with_key:',
  category: 'objects'
}, {
  unicode: '1f511',
  shortname: ':key:',
  category: 'objects'
}, {
  unicode: '1f5dd',
  shortname: ':key2:',
  category: 'objects'
}, {
  unicode: '1f528',
  shortname: ':hammer:',
  category: 'objects'
}, {
  unicode: '26cf',
  shortname: ':pick:',
  category: 'objects'
}, {
  unicode: '2692',
  shortname: ':hammer_pick:',
  category: 'objects'
}, {
  unicode: '1f6e0',
  shortname: ':tools:',
  category: 'objects'
}, {
  unicode: '1f5e1',
  shortname: ':dagger:',
  category: 'objects'
}, {
  unicode: '2694',
  shortname: ':crossed_swords:',
  category: 'objects'
}, {
  unicode: '1f52b',
  shortname: ':gun:',
  category: 'objects'
}, {
  unicode: '1f6e1',
  shortname: ':shield:',
  category: 'objects'
}, {
  unicode: '1f527',
  shortname: ':wrench:',
  category: 'objects'
}, {
  unicode: '1f529',
  shortname: ':nut_and_bolt:',
  category: 'objects'
}, {
  unicode: '2699',
  shortname: ':gear:',
  category: 'objects'
}, {
  unicode: '1f5dc',
  shortname: ':compression:',
  category: 'objects'
}, {
  unicode: '2697',
  shortname: ':alembic:',
  category: 'objects'
}, {
  unicode: '2696',
  shortname: ':scales:',
  category: 'objects'
}, {
  unicode: '1f517',
  shortname: ':link:',
  category: 'objects'
}, {
  unicode: '26d3',
  shortname: ':chains:',
  category: 'objects'
}, {
  unicode: '1f489',
  shortname: ':syringe:',
  category: 'objects'
}, {
  unicode: '1f48a',
  shortname: ':pill:',
  category: 'objects'
}, {
  unicode: '1f6ac',
  shortname: ':smoking:',
  category: 'objects'
}, {
  unicode: '26b0',
  shortname: ':coffin:',
  category: 'objects'
}, {
  unicode: '26b1',
  shortname: ':urn:',
  category: 'objects'
}, {
  unicode: '1f5ff',
  shortname: ':moyai:',
  category: 'objects'
}, {
  unicode: '1f6e2',
  shortname: ':oil:',
  category: 'objects'
}, {
  unicode: '1f52e',
  shortname: ':crystal_ball:',
  category: 'objects'
}, {
  unicode: '1f6d2',
  shortname: ':shopping_cart:',
  category: 'objects'
}, {
  unicode: '1f6a9',
  shortname: ':triangular_flag_on_post:',
  category: 'objects'
}, {
  unicode: '1f38c',
  shortname: ':crossed_flags:',
  category: 'objects'
}, {
  unicode: '1f3f4',
  shortname: ':flag_black:',
  category: 'objects'
}, {
  unicode: '1f3f3',
  shortname: ':flag_white:',
  category: 'objects'
}, {
  unicode: '1f3f3-1f308',
  shortname: ':rainbow_flag:',
  category: 'objects'
}, {
  unicode: '1f600',
  shortname: ':grinning:',
  category: 'people'
}, {
  unicode: '1f601',
  shortname: ':grin:',
  category: 'people'
}, {
  unicode: '1f602',
  shortname: ':joy:',
  category: 'people'
}, {
  unicode: '1f923',
  shortname: ':rofl:',
  category: 'people'
}, {
  unicode: '1f603',
  shortname: ':smiley:',
  category: 'people'
}, {
  unicode: '1f604',
  shortname: ':smile:',
  category: 'people'
}, {
  unicode: '1f605',
  shortname: ':sweat_smile:',
  category: 'people'
}, {
  unicode: '1f606',
  shortname: ':laughing:',
  category: 'people'
}, {
  unicode: '1f609',
  shortname: ':wink:',
  category: 'people'
}, {
  unicode: '1f60a',
  shortname: ':blush:',
  category: 'people'
}, {
  unicode: '1f60b',
  shortname: ':yum:',
  category: 'people'
}, {
  unicode: '1f60e',
  shortname: ':sunglasses:',
  category: 'people'
}, {
  unicode: '1f60d',
  shortname: ':heart_eyes:',
  category: 'people'
}, {
  unicode: '1f618',
  shortname: ':kissing_heart:',
  category: 'people'
}, {
  unicode: '1f617',
  shortname: ':kissing:',
  category: 'people'
}, {
  unicode: '1f619',
  shortname: ':kissing_smiling_eyes:',
  category: 'people'
}, {
  unicode: '1f61a',
  shortname: ':kissing_closed_eyes:',
  category: 'people'
}, {
  unicode: 'fe0f',
  shortname: ':relaxed:',
  category: 'people'
}, {
  unicode: '1f642',
  shortname: ':slight_smile:',
  category: 'people'
}, {
  unicode: '1f917',
  shortname: ':hugging:',
  category: 'people'
}, {
  unicode: '1f914',
  shortname: ':thinking:',
  category: 'people'
}, {
  unicode: '1f610',
  shortname: ':neutral_face:',
  category: 'people'
}, {
  unicode: '1f611',
  shortname: ':expressionless:',
  category: 'people'
}, {
  unicode: '1f636',
  shortname: ':no_mouth:',
  category: 'people'
}, {
  unicode: '1f644',
  shortname: ':rolling_eyes:',
  category: 'people'
}, {
  unicode: '1f60f',
  shortname: ':smirk:',
  category: 'people'
}, {
  unicode: '1f623',
  shortname: ':persevere:',
  category: 'people'
}, {
  unicode: '1f625',
  shortname: ':disappointed_relieved:',
  category: 'people'
}, {
  unicode: '1f62e',
  shortname: ':open_mouth:',
  category: 'people'
}, {
  unicode: '1f910',
  shortname: ':zipper_mouth:',
  category: 'people'
}, {
  unicode: '1f62f',
  shortname: ':hushed:',
  category: 'people'
}, {
  unicode: '1f62a',
  shortname: ':sleepy:',
  category: 'people'
}, {
  unicode: '1f62b',
  shortname: ':tired_face:',
  category: 'people'
}, {
  unicode: '1f634',
  shortname: ':sleeping:',
  category: 'people'
}, {
  unicode: '1f60c',
  shortname: ':relieved:',
  category: 'people'
}, {
  unicode: '1f913',
  shortname: ':nerd:',
  category: 'people'
}, {
  unicode: '1f61b',
  shortname: ':stuck_out_tongue:',
  category: 'people'
}, {
  unicode: '1f61c',
  shortname: ':stuck_out_tongue_winking_eye:',
  category: 'people'
}, {
  unicode: '1f61d',
  shortname: ':stuck_out_tongue_closed_eyes:',
  category: 'people'
}, {
  unicode: '1f924',
  shortname: ':drooling_face:',
  category: 'people'
}, {
  unicode: '1f612',
  shortname: ':unamused:',
  category: 'people'
}, {
  unicode: '1f613',
  shortname: ':sweat:',
  category: 'people'
}, {
  unicode: '1f614',
  shortname: ':pensive:',
  category: 'people'
}, {
  unicode: '1f615',
  shortname: ':confused:',
  category: 'people'
}, {
  unicode: '1f643',
  shortname: ':upside_down:',
  category: 'people'
}, {
  unicode: '1f911',
  shortname: ':money_mouth:',
  category: 'people'
}, {
  unicode: '1f632',
  shortname: ':astonished:',
  category: 'people'
}, {
  unicode: '2639-fe0f',
  shortname: ':frowning2:',
  category: 'people'
}, {
  unicode: '1f641',
  shortname: ':slight_frown:',
  category: 'people'
}, {
  unicode: '1f616',
  shortname: ':confounded:',
  category: 'people'
}, {
  unicode: '1f61e',
  shortname: ':disappointed:',
  category: 'people'
}, {
  unicode: '1f61f',
  shortname: ':worried:',
  category: 'people'
}, {
  unicode: '1f624',
  shortname: ':triumph:',
  category: 'people'
}, {
  unicode: '1f622',
  shortname: ':cry:',
  category: 'people'
}, {
  unicode: '1f62d',
  shortname: ':sob:',
  category: 'people'
}, {
  unicode: '1f626',
  shortname: ':frowning:',
  category: 'people'
}, {
  unicode: '1f627',
  shortname: ':anguished:',
  category: 'people'
}, {
  unicode: '1f628',
  shortname: ':fearful:',
  category: 'people'
}, {
  unicode: '1f629',
  shortname: ':weary:',
  category: 'people'
}, {
  unicode: '1f62c',
  shortname: ':grimacing:',
  category: 'people'
}, {
  unicode: '1f630',
  shortname: ':cold_sweat:',
  category: 'people'
}, {
  unicode: '1f631',
  shortname: ':scream:',
  category: 'people'
}, {
  unicode: '1f633',
  shortname: ':flushed:',
  category: 'people'
}, {
  unicode: '1f635',
  shortname: ':dizzy_face:',
  category: 'people'
}, {
  unicode: '1f621',
  shortname: ':rage:',
  category: 'people'
}, {
  unicode: '1f620',
  shortname: ':angry:',
  category: 'people'
}, {
  unicode: '1f607',
  shortname: ':innocent:',
  category: 'people'
}, {
  unicode: '1f920',
  shortname: ':cowboy:',
  category: 'people'
}, {
  unicode: '1f921',
  shortname: ':clown:',
  category: 'people'
}, {
  unicode: '1f925',
  shortname: ':lying_face:',
  category: 'people'
}, {
  unicode: '1f637',
  shortname: ':mask:',
  category: 'people'
}, {
  unicode: '1f912',
  shortname: ':thermometer_face:',
  category: 'people'
}, {
  unicode: '1f915',
  shortname: ':head_bandage:',
  category: 'people'
}, {
  unicode: '1f922',
  shortname: ':nauseated_face:',
  category: 'people'
}, {
  unicode: '1f927',
  shortname: ':sneezing_face:',
  category: 'people'
}, {
  unicode: '1f608',
  shortname: ':smiling_imp:',
  category: 'people'
}, {
  unicode: '1f47f',
  shortname: ':imp:',
  category: 'people'
}, {
  unicode: '1f479',
  shortname: ':japanese_ogre:',
  category: 'people'
}, {
  unicode: '1f47a',
  shortname: ':japanese_goblin:',
  category: 'people'
}, {
  unicode: '1f480',
  shortname: ':skull:',
  category: 'people'
}, {
  unicode: '1f47b',
  shortname: ':ghost:',
  category: 'people'
}, {
  unicode: '1f47d',
  shortname: ':alien:',
  category: 'people'
}, {
  unicode: '1f916',
  shortname: ':robot:',
  category: 'people'
}, {
  unicode: '1f4a9',
  shortname: ':poop:',
  category: 'people'
}, {
  unicode: '1f63a',
  shortname: ':smiley_cat:',
  category: 'people'
}, {
  unicode: '1f638',
  shortname: ':smile_cat:',
  category: 'people'
}, {
  unicode: '1f639',
  shortname: ':joy_cat:',
  category: 'people'
}, {
  unicode: '1f63b',
  shortname: ':heart_eyes_cat:',
  category: 'people'
}, {
  unicode: '1f63c',
  shortname: ':smirk_cat:',
  category: 'people'
}, {
  unicode: '1f63d',
  shortname: ':kissing_cat:',
  category: 'people'
}, {
  unicode: '1f640',
  shortname: ':scream_cat:',
  category: 'people'
}, {
  unicode: '1f63f',
  shortname: ':crying_cat_face:',
  category: 'people'
}, {
  unicode: '1f63e',
  shortname: ':pouting_cat:',
  category: 'people'
}, {
  unicode: '1f466',
  shortname: ':boy:',
  category: 'people'
}, {
  unicode: '1f466-1f3fb',
  shortname: ':boy_tone1:',
  category: 'people'
}, {
  unicode: '1f466-1f3fc',
  shortname: ':boy_tone2:',
  category: 'people'
}, {
  unicode: '1f466-1f3fd',
  shortname: ':boy_tone3:',
  category: 'people'
}, {
  unicode: '1f466-1f3fe',
  shortname: ':boy_tone4:',
  category: 'people'
}, {
  unicode: '1f466-1f3ff',
  shortname: ':boy_tone5:',
  category: 'people'
}, {
  unicode: '1f467',
  shortname: ':girl:',
  category: 'people'
}, {
  unicode: '1f467-1f3fb',
  shortname: ':girl_tone1:',
  category: 'people'
}, {
  unicode: '1f467-1f3fc',
  shortname: ':girl_tone2:',
  category: 'people'
}, {
  unicode: '1f467-1f3fd',
  shortname: ':girl_tone3:',
  category: 'people'
}, {
  unicode: '1f467-1f3fe',
  shortname: ':girl_tone4:',
  category: 'people'
}, {
  unicode: '1f467-1f3ff',
  shortname: ':girl_tone5:',
  category: 'people'
}, {
  unicode: '1f468',
  shortname: ':man:',
  category: 'people'
}, {
  unicode: '1f468-1f3fb',
  shortname: ':man_tone1:',
  category: 'people'
}, {
  unicode: '1f468-1f3fc',
  shortname: ':man_tone2:',
  category: 'people'
}, {
  unicode: '1f468-1f3fd',
  shortname: ':man_tone3:',
  category: 'people'
}, {
  unicode: '1f468-1f3fe',
  shortname: ':man_tone4:',
  category: 'people'
}, {
  unicode: '1f468-1f3ff',
  shortname: ':man_tone5:',
  category: 'people'
}, {
  unicode: '1f469',
  shortname: ':woman:',
  category: 'people'
}, {
  unicode: '1f469-1f3fb',
  shortname: ':woman_tone1:',
  category: 'people'
}, {
  unicode: '1f469-1f3fc',
  shortname: ':woman_tone2:',
  category: 'people'
}, {
  unicode: '1f469-1f3fd',
  shortname: ':woman_tone3:',
  category: 'people'
}, {
  unicode: '1f469-1f3fe',
  shortname: ':woman_tone4:',
  category: 'people'
}, {
  unicode: '1f469-1f3ff',
  shortname: ':woman_tone5:',
  category: 'people'
}, {
  unicode: '1f474',
  shortname: ':older_man:',
  category: 'people'
}, {
  unicode: '1f474-1f3fb',
  shortname: ':older_man_tone1:',
  category: 'people'
}, {
  unicode: '1f474-1f3fc',
  shortname: ':older_man_tone2:',
  category: 'people'
}, {
  unicode: '1f474-1f3fd',
  shortname: ':older_man_tone3:',
  category: 'people'
}, {
  unicode: '1f474-1f3fe',
  shortname: ':older_man_tone4:',
  category: 'people'
}, {
  unicode: '1f474-1f3ff',
  shortname: ':older_man_tone5:',
  category: 'people'
}, {
  unicode: '1f475',
  shortname: ':older_woman:',
  category: 'people'
}, {
  unicode: '1f475-1f3fb',
  shortname: ':older_woman_tone1:',
  category: 'people'
}, {
  unicode: '1f475-1f3fc',
  shortname: ':older_woman_tone2:',
  category: 'people'
}, {
  unicode: '1f475-1f3fd',
  shortname: ':older_woman_tone3:',
  category: 'people'
}, {
  unicode: '1f475-1f3fe',
  shortname: ':older_woman_tone4:',
  category: 'people'
}, {
  unicode: '1f475-1f3ff',
  shortname: ':older_woman_tone5:',
  category: 'people'
}, {
  unicode: '1f476',
  shortname: ':baby:',
  category: 'people'
}, {
  unicode: '1f476-1f3fb',
  shortname: ':baby_tone1:',
  category: 'people'
}, {
  unicode: '1f476-1f3fc',
  shortname: ':baby_tone2:',
  category: 'people'
}, {
  unicode: '1f476-1f3fd',
  shortname: ':baby_tone3:',
  category: 'people'
}, {
  unicode: '1f476-1f3fe',
  shortname: ':baby_tone4:',
  category: 'people'
}, {
  unicode: '1f476-1f3ff',
  shortname: ':baby_tone5:',
  category: 'people'
}, {
  unicode: '1f47c',
  shortname: ':angel:',
  category: 'people'
}, {
  unicode: '1f47c-1f3fb',
  shortname: ':angel_tone1:',
  category: 'people'
}, {
  unicode: '1f47c-1f3fc',
  shortname: ':angel_tone2:',
  category: 'people'
}, {
  unicode: '1f47c-1f3fd',
  shortname: ':angel_tone3:',
  category: 'people'
}, {
  unicode: '1f47c-1f3fe',
  shortname: ':angel_tone4:',
  category: 'people'
}, {
  unicode: '1f47c-1f3ff',
  shortname: ':angel_tone5:',
  category: 'people'
}, {
  unicode: '1f46e',
  shortname: ':cop:',
  category: 'people'
}, {
  unicode: '1f46e-1f3fb',
  shortname: ':cop_tone1:',
  category: 'people'
}, {
  unicode: '1f46e-1f3fc',
  shortname: ':cop_tone2:',
  category: 'people'
}, {
  unicode: '1f46e-1f3fd',
  shortname: ':cop_tone3:',
  category: 'people'
}, {
  unicode: '1f46e-1f3fe',
  shortname: ':cop_tone4:',
  category: 'people'
}, {
  unicode: '1f46e-1f3ff',
  shortname: ':cop_tone5:',
  category: 'people'
}, {
  unicode: '1f575',
  shortname: ':spy:',
  category: 'people'
}, {
  unicode: '1f575-1f3fb',
  shortname: ':spy_tone1:',
  category: 'people'
}, {
  unicode: '1f575-1f3fc',
  shortname: ':spy_tone2:',
  category: 'people'
}, {
  unicode: '1f575-1f3fd',
  shortname: ':spy_tone3:',
  category: 'people'
}, {
  unicode: '1f575-1f3fe',
  shortname: ':spy_tone4:',
  category: 'people'
}, {
  unicode: '1f575-1f3ff',
  shortname: ':spy_tone5:',
  category: 'people'
}, {
  unicode: '1f482',
  shortname: ':guardsman:',
  category: 'people'
}, {
  unicode: '1f482-1f3fb',
  shortname: ':guardsman_tone1:',
  category: 'people'
}, {
  unicode: '1f482-1f3fc',
  shortname: ':guardsman_tone2:',
  category: 'people'
}, {
  unicode: '1f482-1f3fd',
  shortname: ':guardsman_tone3:',
  category: 'people'
}, {
  unicode: '1f482-1f3fe',
  shortname: ':guardsman_tone4:',
  category: 'people'
}, {
  unicode: '1f482-1f3ff',
  shortname: ':guardsman_tone5:',
  category: 'people'
}, {
  unicode: '1f477',
  shortname: ':construction_worker:',
  category: 'people'
}, {
  unicode: '1f477-1f3fb',
  shortname: ':construction_worker_tone1:',
  category: 'people'
}, {
  unicode: '1f477-1f3fc',
  shortname: ':construction_worker_tone2:',
  category: 'people'
}, {
  unicode: '1f477-1f3fd',
  shortname: ':construction_worker_tone3:',
  category: 'people'
}, {
  unicode: '1f477-1f3fe',
  shortname: ':construction_worker_tone4:',
  category: 'people'
}, {
  unicode: '1f477-1f3ff',
  shortname: ':construction_worker_tone5:',
  category: 'people'
}, {
  unicode: '1f473',
  shortname: ':man_with_turban:',
  category: 'people'
}, {
  unicode: '1f473-1f3fb',
  shortname: ':man_with_turban_tone1:',
  category: 'people'
}, {
  unicode: '1f473-1f3fc',
  shortname: ':man_with_turban_tone2:',
  category: 'people'
}, {
  unicode: '1f473-1f3fd',
  shortname: ':man_with_turban_tone3:',
  category: 'people'
}, {
  unicode: '1f473-1f3fe',
  shortname: ':man_with_turban_tone4:',
  category: 'people'
}, {
  unicode: '1f473-1f3ff',
  shortname: ':man_with_turban_tone5:',
  category: 'people'
}, {
  unicode: '1f471',
  shortname: ':person_with_blond_hair:',
  category: 'people'
}, {
  unicode: '1f471-1f3fb',
  shortname: ':person_with_blond_hair_tone1:',
  category: 'people'
}, {
  unicode: '1f471-1f3fc',
  shortname: ':person_with_blond_hair_tone2:',
  category: 'people'
}, {
  unicode: '1f471-1f3fd',
  shortname: ':person_with_blond_hair_tone3:',
  category: 'people'
}, {
  unicode: '1f471-1f3fe',
  shortname: ':person_with_blond_hair_tone4:',
  category: 'people'
}, {
  unicode: '1f471-1f3ff',
  shortname: ':person_with_blond_hair_tone5:',
  category: 'people'
}, {
  unicode: '1f385',
  shortname: ':santa:',
  category: 'people'
}, {
  unicode: '1f385-1f3fb',
  shortname: ':santa_tone1:',
  category: 'people'
}, {
  unicode: '1f385-1f3fc',
  shortname: ':santa_tone2:',
  category: 'people'
}, {
  unicode: '1f385-1f3fd',
  shortname: ':santa_tone3:',
  category: 'people'
}, {
  unicode: '1f385-1f3fe',
  shortname: ':santa_tone4:',
  category: 'people'
}, {
  unicode: '1f385-1f3ff',
  shortname: ':santa_tone5:',
  category: 'people'
}, {
  unicode: '1f936',
  shortname: ':mrs_claus:',
  category: 'people'
}, {
  unicode: '1f936-1f3fb',
  shortname: ':mrs_claus_tone1:',
  category: 'people'
}, {
  unicode: '1f936-1f3fc',
  shortname: ':mrs_claus_tone2:',
  category: 'people'
}, {
  unicode: '1f936-1f3fd',
  shortname: ':mrs_claus_tone3:',
  category: 'people'
}, {
  unicode: '1f936-1f3fe',
  shortname: ':mrs_claus_tone4:',
  category: 'people'
}, {
  unicode: '1f936-1f3ff',
  shortname: ':mrs_claus_tone5:',
  category: 'people'
}, {
  unicode: '1f478',
  shortname: ':princess:',
  category: 'people'
}, {
  unicode: '1f478-1f3fb',
  shortname: ':princess_tone1:',
  category: 'people'
}, {
  unicode: '1f478-1f3fc',
  shortname: ':princess_tone2:',
  category: 'people'
}, {
  unicode: '1f478-1f3fd',
  shortname: ':princess_tone3:',
  category: 'people'
}, {
  unicode: '1f478-1f3fe',
  shortname: ':princess_tone4:',
  category: 'people'
}, {
  unicode: '1f478-1f3ff',
  shortname: ':princess_tone5:',
  category: 'people'
}, {
  unicode: '1f934',
  shortname: ':prince:',
  category: 'people'
}, {
  unicode: '1f934-1f3fb',
  shortname: ':prince_tone1:',
  category: 'people'
}, {
  unicode: '1f934-1f3fc',
  shortname: ':prince_tone2:',
  category: 'people'
}, {
  unicode: '1f934-1f3fd',
  shortname: ':prince_tone3:',
  category: 'people'
}, {
  unicode: '1f934-1f3fe',
  shortname: ':prince_tone4:',
  category: 'people'
}, {
  unicode: '1f934-1f3ff',
  shortname: ':prince_tone5:',
  category: 'people'
}, {
  unicode: '1f470',
  shortname: ':bride_with_veil:',
  category: 'people'
}, {
  unicode: '1f470-1f3fb',
  shortname: ':bride_with_veil_tone1:',
  category: 'people'
}, {
  unicode: '1f470-1f3fc',
  shortname: ':bride_with_veil_tone2:',
  category: 'people'
}, {
  unicode: '1f470-1f3fd',
  shortname: ':bride_with_veil_tone3:',
  category: 'people'
}, {
  unicode: '1f470-1f3fe',
  shortname: ':bride_with_veil_tone4:',
  category: 'people'
}, {
  unicode: '1f470-1f3ff',
  shortname: ':bride_with_veil_tone5:',
  category: 'people'
}, {
  unicode: '1f935',
  shortname: ':man_in_tuxedo:',
  category: 'people'
}, {
  unicode: '1f935-1f3fb',
  shortname: ':man_in_tuxedo_tone1:',
  category: 'people'
}, {
  unicode: '1f935-1f3fc',
  shortname: ':man_in_tuxedo_tone2:',
  category: 'people'
}, {
  unicode: '1f935-1f3fd',
  shortname: ':man_in_tuxedo_tone3:',
  category: 'people'
}, {
  unicode: '1f935-1f3fe',
  shortname: ':man_in_tuxedo_tone4:',
  category: 'people'
}, {
  unicode: '1f935-1f3ff',
  shortname: ':man_in_tuxedo_tone5:',
  category: 'people'
}, {
  unicode: '1f930',
  shortname: ':pregnant_woman:',
  category: 'people'
}, {
  unicode: '1f930-1f3fb',
  shortname: ':pregnant_woman_tone1:',
  category: 'people'
}, {
  unicode: '1f930-1f3fc',
  shortname: ':pregnant_woman_tone2:',
  category: 'people'
}, {
  unicode: '1f930-1f3fd',
  shortname: ':pregnant_woman_tone3:',
  category: 'people'
}, {
  unicode: '1f930-1f3fe',
  shortname: ':pregnant_woman_tone4:',
  category: 'people'
}, {
  unicode: '1f930-1f3ff',
  shortname: ':pregnant_woman_tone5:',
  category: 'people'
}, {
  unicode: '1f472',
  shortname: ':man_with_gua_pi_mao:',
  category: 'people'
}, {
  unicode: '1f472-1f3fb',
  shortname: ':man_with_gua_pi_mao_tone1:',
  category: 'people'
}, {
  unicode: '1f472-1f3fc',
  shortname: ':man_with_gua_pi_mao_tone2:',
  category: 'people'
}, {
  unicode: '1f472-1f3fd',
  shortname: ':man_with_gua_pi_mao_tone3:',
  category: 'people'
}, {
  unicode: '1f472-1f3fe',
  shortname: ':man_with_gua_pi_mao_tone4:',
  category: 'people'
}, {
  unicode: '1f472-1f3ff',
  shortname: ':man_with_gua_pi_mao_tone5:',
  category: 'people'
}, {
  unicode: '1f64d',
  shortname: ':person_frowning:',
  category: 'people'
}, {
  unicode: '1f64d-1f3fb',
  shortname: ':person_frowning_tone1:',
  category: 'people'
}, {
  unicode: '1f64d-1f3fc',
  shortname: ':person_frowning_tone2:',
  category: 'people'
}, {
  unicode: '1f64d-1f3fd',
  shortname: ':person_frowning_tone3:',
  category: 'people'
}, {
  unicode: '1f64d-1f3fe',
  shortname: ':person_frowning_tone4:',
  category: 'people'
}, {
  unicode: '1f64d-1f3ff',
  shortname: ':person_frowning_tone5:',
  category: 'people'
}, {
  unicode: '1f64e',
  shortname: ':person_with_pouting_face:',
  category: 'people'
}, {
  unicode: '1f64e-1f3fb',
  shortname: ':person_with_pouting_face_tone1:',
  category: 'people'
}, {
  unicode: '1f64e-1f3fc',
  shortname: ':person_with_pouting_face_tone2:',
  category: 'people'
}, {
  unicode: '1f64e-1f3fd',
  shortname: ':person_with_pouting_face_tone3:',
  category: 'people'
}, {
  unicode: '1f64e-1f3fe',
  shortname: ':person_with_pouting_face_tone4:',
  category: 'people'
}, {
  unicode: '1f64e-1f3ff',
  shortname: ':person_with_pouting_face_tone5:',
  category: 'people'
}, {
  unicode: '1f645',
  shortname: ':no_good:',
  category: 'people'
}, {
  unicode: '1f645-1f3fb',
  shortname: ':no_good_tone1:',
  category: 'people'
}, {
  unicode: '1f645-1f3fc',
  shortname: ':no_good_tone2:',
  category: 'people'
}, {
  unicode: '1f645-1f3fd',
  shortname: ':no_good_tone3:',
  category: 'people'
}, {
  unicode: '1f645-1f3fe',
  shortname: ':no_good_tone4:',
  category: 'people'
}, {
  unicode: '1f645-1f3ff',
  shortname: ':no_good_tone5:',
  category: 'people'
}, {
  unicode: '1f646',
  shortname: ':ok_woman:',
  category: 'people'
}, {
  unicode: '1f646-1f3fb',
  shortname: ':ok_woman_tone1:',
  category: 'people'
}, {
  unicode: '1f646-1f3fc',
  shortname: ':ok_woman_tone2:',
  category: 'people'
}, {
  unicode: '1f646-1f3fd',
  shortname: ':ok_woman_tone3:',
  category: 'people'
}, {
  unicode: '1f646-1f3fe',
  shortname: ':ok_woman_tone4:',
  category: 'people'
}, {
  unicode: '1f646-1f3ff',
  shortname: ':ok_woman_tone5:',
  category: 'people'
}, {
  unicode: '1f481',
  shortname: ':information_desk_person:',
  category: 'people'
}, {
  unicode: '1f481-1f3fb',
  shortname: ':information_desk_person_tone1:',
  category: 'people'
}, {
  unicode: '1f481-1f3fc',
  shortname: ':information_desk_person_tone2:',
  category: 'people'
}, {
  unicode: '1f481-1f3fd',
  shortname: ':information_desk_person_tone3:',
  category: 'people'
}, {
  unicode: '1f481-1f3fe',
  shortname: ':information_desk_person_tone4:',
  category: 'people'
}, {
  unicode: '1f481-1f3ff',
  shortname: ':information_desk_person_tone5:',
  category: 'people'
}, {
  unicode: '1f64b',
  shortname: ':raising_hand:',
  category: 'people'
}, {
  unicode: '1f64b-1f3fb',
  shortname: ':raising_hand_tone1:',
  category: 'people'
}, {
  unicode: '1f64b-1f3fc',
  shortname: ':raising_hand_tone2:',
  category: 'people'
}, {
  unicode: '1f64b-1f3fd',
  shortname: ':raising_hand_tone3:',
  category: 'people'
}, {
  unicode: '1f64b-1f3fe',
  shortname: ':raising_hand_tone4:',
  category: 'people'
}, {
  unicode: '1f64b-1f3ff',
  shortname: ':raising_hand_tone5:',
  category: 'people'
}, {
  unicode: '1f647',
  shortname: ':bow:',
  category: 'people'
}, {
  unicode: '1f647-1f3fb',
  shortname: ':bow_tone1:',
  category: 'people'
}, {
  unicode: '1f647-1f3fc',
  shortname: ':bow_tone2:',
  category: 'people'
}, {
  unicode: '1f647-1f3fd',
  shortname: ':bow_tone3:',
  category: 'people'
}, {
  unicode: '1f647-1f3fe',
  shortname: ':bow_tone4:',
  category: 'people'
}, {
  unicode: '1f647-1f3ff',
  shortname: ':bow_tone5:',
  category: 'people'
}, {
  unicode: '1f926',
  shortname: ':face_palm:',
  category: 'people'
}, {
  unicode: '1f926-1f3fb',
  shortname: ':face_palm_tone1:',
  category: 'people'
}, {
  unicode: '1f926-1f3fc',
  shortname: ':face_palm_tone2:',
  category: 'people'
}, {
  unicode: '1f926-1f3fd',
  shortname: ':face_palm_tone3:',
  category: 'people'
}, {
  unicode: '1f926-1f3fe',
  shortname: ':face_palm_tone4:',
  category: 'people'
}, {
  unicode: '1f926-1f3ff',
  shortname: ':face_palm_tone5:',
  category: 'people'
}, {
  unicode: '1f937',
  shortname: ':shrug:',
  category: 'people'
}, {
  unicode: '1f937-1f3fb',
  shortname: ':shrug_tone1:',
  category: 'people'
}, {
  unicode: '1f937-1f3fc',
  shortname: ':shrug_tone2:',
  category: 'people'
}, {
  unicode: '1f937-1f3fd',
  shortname: ':shrug_tone3:',
  category: 'people'
}, {
  unicode: '1f937-1f3fe',
  shortname: ':shrug_tone4:',
  category: 'people'
}, {
  unicode: '1f937-1f3ff',
  shortname: ':shrug_tone5:',
  category: 'people'
}, {
  unicode: '1f486',
  shortname: ':massage:',
  category: 'people'
}, {
  unicode: '1f486-1f3fb',
  shortname: ':massage_tone1:',
  category: 'people'
}, {
  unicode: '1f486-1f3fc',
  shortname: ':massage_tone2:',
  category: 'people'
}, {
  unicode: '1f486-1f3fd',
  shortname: ':massage_tone3:',
  category: 'people'
}, {
  unicode: '1f486-1f3fe',
  shortname: ':massage_tone4:',
  category: 'people'
}, {
  unicode: '1f486-1f3ff',
  shortname: ':massage_tone5:',
  category: 'people'
}, {
  unicode: '1f487',
  shortname: ':haircut:',
  category: 'people'
}, {
  unicode: '1f487-1f3fb',
  shortname: ':haircut_tone1:',
  category: 'people'
}, {
  unicode: '1f487-1f3fc',
  shortname: ':haircut_tone2:',
  category: 'people'
}, {
  unicode: '1f487-1f3fd',
  shortname: ':haircut_tone3:',
  category: 'people'
}, {
  unicode: '1f487-1f3fe',
  shortname: ':haircut_tone4:',
  category: 'people'
}, {
  unicode: '1f487-1f3ff',
  shortname: ':haircut_tone5:',
  category: 'people'
}, {
  unicode: '1f6b6',
  shortname: ':walking:',
  category: 'people'
}, {
  unicode: '1f6b6-1f3fb',
  shortname: ':walking_tone1:',
  category: 'people'
}, {
  unicode: '1f6b6-1f3fc',
  shortname: ':walking_tone2:',
  category: 'people'
}, {
  unicode: '1f6b6-1f3fd',
  shortname: ':walking_tone3:',
  category: 'people'
}, {
  unicode: '1f6b6-1f3fe',
  shortname: ':walking_tone4:',
  category: 'people'
}, {
  unicode: '1f6b6-1f3ff',
  shortname: ':walking_tone5:',
  category: 'people'
}, {
  unicode: '1f3c3',
  shortname: ':runner:',
  category: 'people'
}, {
  unicode: '1f3c3-1f3fb',
  shortname: ':runner_tone1:',
  category: 'people'
}, {
  unicode: '1f3c3-1f3fc',
  shortname: ':runner_tone2:',
  category: 'people'
}, {
  unicode: '1f3c3-1f3fd',
  shortname: ':runner_tone3:',
  category: 'people'
}, {
  unicode: '1f3c3-1f3fe',
  shortname: ':runner_tone4:',
  category: 'people'
}, {
  unicode: '1f3c3-1f3ff',
  shortname: ':runner_tone5:',
  category: 'people'
}, {
  unicode: '1f483',
  shortname: ':dancer:',
  category: 'people'
}, {
  unicode: '1f483-1f3fb',
  shortname: ':dancer_tone1:',
  category: 'people'
}, {
  unicode: '1f483-1f3fc',
  shortname: ':dancer_tone2:',
  category: 'people'
}, {
  unicode: '1f483-1f3fd',
  shortname: ':dancer_tone3:',
  category: 'people'
}, {
  unicode: '1f483-1f3fe',
  shortname: ':dancer_tone4:',
  category: 'people'
}, {
  unicode: '1f483-1f3ff',
  shortname: ':dancer_tone5:',
  category: 'people'
}, {
  unicode: '1f57a',
  shortname: ':man_dancing:',
  category: 'people'
}, {
  unicode: '1f57a-1f3fb',
  shortname: ':man_dancing_tone1:',
  category: 'people'
}, {
  unicode: '1f57a-1f3fc',
  shortname: ':man_dancing_tone2:',
  category: 'people'
}, {
  unicode: '1f57a-1f3fd',
  shortname: ':man_dancing_tone3:',
  category: 'people'
}, {
  unicode: '1f57a-1f3fe',
  shortname: ':man_dancing_tone4:',
  category: 'people'
}, {
  unicode: '1f57a-1f3ff',
  shortname: ':man_dancing_tone5:',
  category: 'people'
}, {
  unicode: '1f46f',
  shortname: ':dancers:',
  category: 'people'
}, {
  unicode: '1f5e3',
  shortname: ':speaking_head:',
  category: 'people'
}, {
  unicode: '1f464',
  shortname: ':bust_in_silhouette:',
  category: 'people'
}, {
  unicode: '1f465',
  shortname: ':busts_in_silhouette:',
  category: 'people'
}, {
  unicode: '1f46b',
  shortname: ':couple:',
  category: 'people'
}, {
  unicode: '1f46c',
  shortname: ':two_men_holding_hands:',
  category: 'people'
}, {
  unicode: '1f46d',
  shortname: ':two_women_holding_hands:',
  category: 'people'
}, {
  unicode: '1f48f',
  shortname: ':couplekiss:',
  category: 'people'
}, {
  unicode: '1f468-2764-1f48b-1f468',
  shortname: ':kiss_mm:',
  category: 'people'
}, {
  unicode: '1f469-2764-1f48b-1f469',
  shortname: ':kiss_ww:',
  category: 'people'
}, {
  unicode: '1f491',
  shortname: ':couple_with_heart:',
  category: 'people'
}, {
  unicode: '1f468-2764-1f468',
  shortname: ':couple_mm:',
  category: 'people'
}, {
  unicode: '1f469-2764-1f469',
  shortname: ':couple_ww:',
  category: 'people'
}, {
  unicode: '1f46a',
  shortname: ':family:',
  category: 'people'
}, {
  unicode: '1f468-1f469-1f467',
  shortname: ':family_mwg:',
  category: 'people'
}, {
  unicode: '1f468-1f469-1f467-1f466',
  shortname: ':family_mwgb:',
  category: 'people'
}, {
  unicode: '1f468-1f469-1f466-1f466',
  shortname: ':family_mwbb:',
  category: 'people'
}, {
  unicode: '1f468-1f469-1f467-1f467',
  shortname: ':family_mwgg:',
  category: 'people'
}, {
  unicode: '1f468-1f468-1f466',
  shortname: ':family_mmb:',
  category: 'people'
}, {
  unicode: '1f468-1f468-1f467',
  shortname: ':family_mmg:',
  category: 'people'
}, {
  unicode: '1f468-1f468-1f467-1f466',
  shortname: ':family_mmgb:',
  category: 'people'
}, {
  unicode: '1f468-1f468-1f466-1f466',
  shortname: ':family_mmbb:',
  category: 'people'
}, {
  unicode: '1f468-1f468-1f467-1f467',
  shortname: ':family_mmgg:',
  category: 'people'
}, {
  unicode: '1f469-1f469-1f466',
  shortname: ':family_wwb:',
  category: 'people'
}, {
  unicode: '1f469-1f469-1f467',
  shortname: ':family_wwg:',
  category: 'people'
}, {
  unicode: '1f469-1f469-1f467-1f466',
  shortname: ':family_wwgb:',
  category: 'people'
}, {
  unicode: '1f469-1f469-1f466-1f466',
  shortname: ':family_wwbb:',
  category: 'people'
}, {
  unicode: '1f469-1f469-1f467-1f467',
  shortname: ':family_wwgg:',
  category: 'people'
}, {
  unicode: '1f4aa',
  shortname: ':muscle:',
  category: 'people'
}, {
  unicode: '1f4aa-1f3fb',
  shortname: ':muscle_tone1:',
  category: 'people'
}, {
  unicode: '1f4aa-1f3fc',
  shortname: ':muscle_tone2:',
  category: 'people'
}, {
  unicode: '1f4aa-1f3fd',
  shortname: ':muscle_tone3:',
  category: 'people'
}, {
  unicode: '1f4aa-1f3fe',
  shortname: ':muscle_tone4:',
  category: 'people'
}, {
  unicode: '1f4aa-1f3ff',
  shortname: ':muscle_tone5:',
  category: 'people'
}, {
  unicode: '1f933',
  shortname: ':selfie:',
  category: 'people'
}, {
  unicode: '1f933-1f3fb',
  shortname: ':selfie_tone1:',
  category: 'people'
}, {
  unicode: '1f933-1f3fc',
  shortname: ':selfie_tone2:',
  category: 'people'
}, {
  unicode: '1f933-1f3fd',
  shortname: ':selfie_tone3:',
  category: 'people'
}, {
  unicode: '1f933-1f3fe',
  shortname: ':selfie_tone4:',
  category: 'people'
}, {
  unicode: '1f933-1f3ff',
  shortname: ':selfie_tone5:',
  category: 'people'
}, {
  unicode: '1f448',
  shortname: ':point_left:',
  category: 'people'
}, {
  unicode: '1f448-1f3fb',
  shortname: ':point_left_tone1:',
  category: 'people'
}, {
  unicode: '1f448-1f3fc',
  shortname: ':point_left_tone2:',
  category: 'people'
}, {
  unicode: '1f448-1f3fd',
  shortname: ':point_left_tone3:',
  category: 'people'
}, {
  unicode: '1f448-1f3fe',
  shortname: ':point_left_tone4:',
  category: 'people'
}, {
  unicode: '1f448-1f3ff',
  shortname: ':point_left_tone5:',
  category: 'people'
}, {
  unicode: '1f449',
  shortname: ':point_right:',
  category: 'people'
}, {
  unicode: '1f449-1f3fb',
  shortname: ':point_right_tone1:',
  category: 'people'
}, {
  unicode: '1f449-1f3fc',
  shortname: ':point_right_tone2:',
  category: 'people'
}, {
  unicode: '1f449-1f3fd',
  shortname: ':point_right_tone3:',
  category: 'people'
}, {
  unicode: '1f449-1f3fe',
  shortname: ':point_right_tone4:',
  category: 'people'
}, {
  unicode: '1f449-1f3ff',
  shortname: ':point_right_tone5:',
  category: 'people'
}, {
  unicode: '261d',
  shortname: ':point_up:',
  category: 'people'
}, {
  unicode: '261d-1f3fb',
  shortname: ':point_up_tone1:',
  category: 'people'
}, {
  unicode: '261d-1f3fc',
  shortname: ':point_up_tone2:',
  category: 'people'
}, {
  unicode: '261d-1f3fd',
  shortname: ':point_up_tone3:',
  category: 'people'
}, {
  unicode: '261d-1f3fe',
  shortname: ':point_up_tone4:',
  category: 'people'
}, {
  unicode: '261d-1f3ff',
  shortname: ':point_up_tone5:',
  category: 'people'
}, {
  unicode: '1f446',
  shortname: ':point_up_2:',
  category: 'people'
}, {
  unicode: '1f446-1f3fb',
  shortname: ':point_up_2_tone1:',
  category: 'people'
}, {
  unicode: '1f446-1f3fc',
  shortname: ':point_up_2_tone2:',
  category: 'people'
}, {
  unicode: '1f446-1f3fd',
  shortname: ':point_up_2_tone3:',
  category: 'people'
}, {
  unicode: '1f446-1f3fe',
  shortname: ':point_up_2_tone4:',
  category: 'people'
}, {
  unicode: '1f446-1f3ff',
  shortname: ':point_up_2_tone5:',
  category: 'people'
}, {
  unicode: '1f447',
  shortname: ':point_down:',
  category: 'people'
}, {
  unicode: '1f447-1f3fb',
  shortname: ':point_down_tone1:',
  category: 'people'
}, {
  unicode: '1f447-1f3fc',
  shortname: ':point_down_tone2:',
  category: 'people'
}, {
  unicode: '1f447-1f3fd',
  shortname: ':point_down_tone3:',
  category: 'people'
}, {
  unicode: '1f447-1f3fe',
  shortname: ':point_down_tone4:',
  category: 'people'
}, {
  unicode: '1f447-1f3ff',
  shortname: ':point_down_tone5:',
  category: 'people'
}, {
  unicode: '270c',
  shortname: ':v:',
  category: 'people'
}, {
  unicode: '270c-1f3fb',
  shortname: ':v_tone1:',
  category: 'people'
}, {
  unicode: '270c-1f3fc',
  shortname: ':v_tone2:',
  category: 'people'
}, {
  unicode: '270c-1f3fd',
  shortname: ':v_tone3:',
  category: 'people'
}, {
  unicode: '270c-1f3fe',
  shortname: ':v_tone4:',
  category: 'people'
}, {
  unicode: '270c-1f3ff',
  shortname: ':v_tone5:',
  category: 'people'
}, {
  unicode: '1f91e',
  shortname: ':fingers_crossed:',
  category: 'people'
}, {
  unicode: '1f91e-1f3fb',
  shortname: ':fingers_crossed_tone1:',
  category: 'people'
}, {
  unicode: '1f91e-1f3fc',
  shortname: ':fingers_crossed_tone2:',
  category: 'people'
}, {
  unicode: '1f91e-1f3fd',
  shortname: ':fingers_crossed_tone3:',
  category: 'people'
}, {
  unicode: '1f91e-1f3fe',
  shortname: ':fingers_crossed_tone4:',
  category: 'people'
}, {
  unicode: '1f91e-1f3ff',
  shortname: ':fingers_crossed_tone5:',
  category: 'people'
}, {
  unicode: '1f596',
  shortname: ':vulcan:',
  category: 'people'
}, {
  unicode: '1f596-1f3fb',
  shortname: ':vulcan_tone1:',
  category: 'people'
}, {
  unicode: '1f596-1f3fc',
  shortname: ':vulcan_tone2:',
  category: 'people'
}, {
  unicode: '1f596-1f3fd',
  shortname: ':vulcan_tone3:',
  category: 'people'
}, {
  unicode: '1f596-1f3fe',
  shortname: ':vulcan_tone4:',
  category: 'people'
}, {
  unicode: '1f596-1f3ff',
  shortname: ':vulcan_tone5:',
  category: 'people'
}, {
  unicode: '1f918',
  shortname: ':metal:',
  category: 'people'
}, {
  unicode: '1f918-1f3fb',
  shortname: ':metal_tone1:',
  category: 'people'
}, {
  unicode: '1f918-1f3fc',
  shortname: ':metal_tone2:',
  category: 'people'
}, {
  unicode: '1f918-1f3fd',
  shortname: ':metal_tone3:',
  category: 'people'
}, {
  unicode: '1f918-1f3fe',
  shortname: ':metal_tone4:',
  category: 'people'
}, {
  unicode: '1f918-1f3ff',
  shortname: ':metal_tone5:',
  category: 'people'
}, {
  unicode: '1f919',
  shortname: ':call_me:',
  category: 'people'
}, {
  unicode: '1f919-1f3fb',
  shortname: ':call_me_tone1:',
  category: 'people'
}, {
  unicode: '1f919-1f3fc',
  shortname: ':call_me_tone2:',
  category: 'people'
}, {
  unicode: '1f919-1f3fd',
  shortname: ':call_me_tone3:',
  category: 'people'
}, {
  unicode: '1f919-1f3fe',
  shortname: ':call_me_tone4:',
  category: 'people'
}, {
  unicode: '1f919-1f3ff',
  shortname: ':call_me_tone5:',
  category: 'people'
}, {
  unicode: '1f590',
  shortname: ':hand_splayed:',
  category: 'people'
}, {
  unicode: '1f590-1f3fb',
  shortname: ':hand_splayed_tone1:',
  category: 'people'
}, {
  unicode: '1f590-1f3fc',
  shortname: ':hand_splayed_tone2:',
  category: 'people'
}, {
  unicode: '1f590-1f3fd',
  shortname: ':hand_splayed_tone3:',
  category: 'people'
}, {
  unicode: '1f590-1f3fe',
  shortname: ':hand_splayed_tone4:',
  category: 'people'
}, {
  unicode: '1f590-1f3ff',
  shortname: ':hand_splayed_tone5:',
  category: 'people'
}, {
  unicode: '270b',
  shortname: ':raised_hand:',
  category: 'people'
}, {
  unicode: '270b-1f3fb',
  shortname: ':raised_hand_tone1:',
  category: 'people'
}, {
  unicode: '270b-1f3fc',
  shortname: ':raised_hand_tone2:',
  category: 'people'
}, {
  unicode: '270b-1f3fd',
  shortname: ':raised_hand_tone3:',
  category: 'people'
}, {
  unicode: '270b-1f3fe',
  shortname: ':raised_hand_tone4:',
  category: 'people'
}, {
  unicode: '270b-1f3ff',
  shortname: ':raised_hand_tone5:',
  category: 'people'
}, {
  unicode: '1f44c',
  shortname: ':ok_hand:',
  category: 'people'
}, {
  unicode: '1f44c-1f3fb',
  shortname: ':ok_hand_tone1:',
  category: 'people'
}, {
  unicode: '1f44c-1f3fc',
  shortname: ':ok_hand_tone2:',
  category: 'people'
}, {
  unicode: '1f44c-1f3fd',
  shortname: ':ok_hand_tone3:',
  category: 'people'
}, {
  unicode: '1f44c-1f3fe',
  shortname: ':ok_hand_tone4:',
  category: 'people'
}, {
  unicode: '1f44c-1f3ff',
  shortname: ':ok_hand_tone5:',
  category: 'people'
}, {
  unicode: '1f44d',
  shortname: ':thumbsup:',
  category: 'people'
}, {
  unicode: '1f44d-1f3fb',
  shortname: ':thumbsup_tone1:',
  category: 'people'
}, {
  unicode: '1f44d-1f3fc',
  shortname: ':thumbsup_tone2:',
  category: 'people'
}, {
  unicode: '1f44d-1f3fd',
  shortname: ':thumbsup_tone3:',
  category: 'people'
}, {
  unicode: '1f44d-1f3fe',
  shortname: ':thumbsup_tone4:',
  category: 'people'
}, {
  unicode: '1f44d-1f3ff',
  shortname: ':thumbsup_tone5:',
  category: 'people'
}, {
  unicode: '1f44e',
  shortname: ':thumbsdown:',
  category: 'people'
}, {
  unicode: '1f44e-1f3fb',
  shortname: ':thumbsdown_tone1:',
  category: 'people'
}, {
  unicode: '1f44e-1f3fc',
  shortname: ':thumbsdown_tone2:',
  category: 'people'
}, {
  unicode: '1f44e-1f3fd',
  shortname: ':thumbsdown_tone3:',
  category: 'people'
}, {
  unicode: '1f44e-1f3fe',
  shortname: ':thumbsdown_tone4:',
  category: 'people'
}, {
  unicode: '1f44e-1f3ff',
  shortname: ':thumbsdown_tone5:',
  category: 'people'
}, {
  unicode: '270a',
  shortname: ':fist:',
  category: 'people'
}, {
  unicode: '270a-1f3fb',
  shortname: ':fist_tone1:',
  category: 'people'
}, {
  unicode: '270a-1f3fc',
  shortname: ':fist_tone2:',
  category: 'people'
}, {
  unicode: '270a-1f3fd',
  shortname: ':fist_tone3:',
  category: 'people'
}, {
  unicode: '270a-1f3fe',
  shortname: ':fist_tone4:',
  category: 'people'
}, {
  unicode: '270a-1f3ff',
  shortname: ':fist_tone5:',
  category: 'people'
}, {
  unicode: '1f44a',
  shortname: ':punch:',
  category: 'people'
}, {
  unicode: '1f44a-1f3fb',
  shortname: ':punch_tone1:',
  category: 'people'
}, {
  unicode: '1f44a-1f3fc',
  shortname: ':punch_tone2:',
  category: 'people'
}, {
  unicode: '1f44a-1f3fd',
  shortname: ':punch_tone3:',
  category: 'people'
}, {
  unicode: '1f44a-1f3fe',
  shortname: ':punch_tone4:',
  category: 'people'
}, {
  unicode: '1f44a-1f3ff',
  shortname: ':punch_tone5:',
  category: 'people'
}, {
  unicode: '1f91b',
  shortname: ':left_facing_fist:',
  category: 'people'
}, {
  unicode: '1f91b-1f3fb',
  shortname: ':left_facing_fist_tone1:',
  category: 'people'
}, {
  unicode: '1f91b-1f3fc',
  shortname: ':left_facing_fist_tone2:',
  category: 'people'
}, {
  unicode: '1f91b-1f3fd',
  shortname: ':left_facing_fist_tone3:',
  category: 'people'
}, {
  unicode: '1f91b-1f3fe',
  shortname: ':left_facing_fist_tone4:',
  category: 'people'
}, {
  unicode: '1f91b-1f3ff',
  shortname: ':left_facing_fist_tone5:',
  category: 'people'
}, {
  unicode: '1f91c',
  shortname: ':right_facing_fist:',
  category: 'people'
}, {
  unicode: '1f91c-1f3fb',
  shortname: ':right_facing_fist_tone1:',
  category: 'people'
}, {
  unicode: '1f91c-1f3fc',
  shortname: ':right_facing_fist_tone2:',
  category: 'people'
}, {
  unicode: '1f91c-1f3fd',
  shortname: ':right_facing_fist_tone3:',
  category: 'people'
}, {
  unicode: '1f91c-1f3fe',
  shortname: ':right_facing_fist_tone4:',
  category: 'people'
}, {
  unicode: '1f91c-1f3ff',
  shortname: ':right_facing_fist_tone5:',
  category: 'people'
}, {
  unicode: '1f91a',
  shortname: ':raised_back_of_hand:',
  category: 'people'
}, {
  unicode: '1f91a-1f3fb',
  shortname: ':raised_back_of_hand_tone1:',
  category: 'people'
}, {
  unicode: '1f91a-1f3fc',
  shortname: ':raised_back_of_hand_tone2:',
  category: 'people'
}, {
  unicode: '1f91a-1f3fd',
  shortname: ':raised_back_of_hand_tone3:',
  category: 'people'
}, {
  unicode: '1f91a-1f3fe',
  shortname: ':raised_back_of_hand_tone4:',
  category: 'people'
}, {
  unicode: '1f91a-1f3ff',
  shortname: ':raised_back_of_hand_tone5:',
  category: 'people'
}, {
  unicode: '1f44b',
  shortname: ':wave:',
  category: 'people'
}, {
  unicode: '1f44b-1f3fb',
  shortname: ':wave_tone1:',
  category: 'people'
}, {
  unicode: '1f44b-1f3fc',
  shortname: ':wave_tone2:',
  category: 'people'
}, {
  unicode: '1f44b-1f3fd',
  shortname: ':wave_tone3:',
  category: 'people'
}, {
  unicode: '1f44b-1f3fe',
  shortname: ':wave_tone4:',
  category: 'people'
}, {
  unicode: '1f44b-1f3ff',
  shortname: ':wave_tone5:',
  category: 'people'
}, {
  unicode: '1f44f',
  shortname: ':clap:',
  category: 'people'
}, {
  unicode: '1f44f-1f3fb',
  shortname: ':clap_tone1:',
  category: 'people'
}, {
  unicode: '1f44f-1f3fc',
  shortname: ':clap_tone2:',
  category: 'people'
}, {
  unicode: '1f44f-1f3fd',
  shortname: ':clap_tone3:',
  category: 'people'
}, {
  unicode: '1f44f-1f3fe',
  shortname: ':clap_tone4:',
  category: 'people'
}, {
  unicode: '1f44f-1f3ff',
  shortname: ':clap_tone5:',
  category: 'people'
}, {
  unicode: '270d',
  shortname: ':writing_hand:',
  category: 'people'
}, {
  unicode: '270d-1f3fb',
  shortname: ':writing_hand_tone1:',
  category: 'people'
}, {
  unicode: '270d-1f3fc',
  shortname: ':writing_hand_tone2:',
  category: 'people'
}, {
  unicode: '270d-1f3fd',
  shortname: ':writing_hand_tone3:',
  category: 'people'
}, {
  unicode: '270d-1f3fe',
  shortname: ':writing_hand_tone4:',
  category: 'people'
}, {
  unicode: '270d-1f3ff',
  shortname: ':writing_hand_tone5:',
  category: 'people'
}, {
  unicode: '1f450',
  shortname: ':open_hands:',
  category: 'people'
}, {
  unicode: '1f450-1f3fb',
  shortname: ':open_hands_tone1:',
  category: 'people'
}, {
  unicode: '1f450-1f3fc',
  shortname: ':open_hands_tone2:',
  category: 'people'
}, {
  unicode: '1f450-1f3fd',
  shortname: ':open_hands_tone3:',
  category: 'people'
}, {
  unicode: '1f450-1f3fe',
  shortname: ':open_hands_tone4:',
  category: 'people'
}, {
  unicode: '1f450-1f3ff',
  shortname: ':open_hands_tone5:',
  category: 'people'
}, {
  unicode: '1f64c',
  shortname: ':raised_hands:',
  category: 'people'
}, {
  unicode: '1f64c-1f3fb',
  shortname: ':raised_hands_tone1:',
  category: 'people'
}, {
  unicode: '1f64c-1f3fc',
  shortname: ':raised_hands_tone2:',
  category: 'people'
}, {
  unicode: '1f64c-1f3fd',
  shortname: ':raised_hands_tone3:',
  category: 'people'
}, {
  unicode: '1f64c-1f3fe',
  shortname: ':raised_hands_tone4:',
  category: 'people'
}, {
  unicode: '1f64c-1f3ff',
  shortname: ':raised_hands_tone5:',
  category: 'people'
}, {
  unicode: '1f64f',
  shortname: ':pray:',
  category: 'people'
}, {
  unicode: '1f64f-1f3fb',
  shortname: ':pray_tone1:',
  category: 'people'
}, {
  unicode: '1f64f-1f3fc',
  shortname: ':pray_tone2:',
  category: 'people'
}, {
  unicode: '1f64f-1f3fd',
  shortname: ':pray_tone3:',
  category: 'people'
}, {
  unicode: '1f64f-1f3fe',
  shortname: ':pray_tone4:',
  category: 'people'
}, {
  unicode: '1f64f-1f3ff',
  shortname: ':pray_tone5:',
  category: 'people'
}, {
  unicode: '1f91d',
  shortname: ':handshake:',
  category: 'people'
}, {
  unicode: '1f91d-1f3fb',
  shortname: ':handshake_tone1:',
  category: 'people'
}, {
  unicode: '1f91d-1f3fc',
  shortname: ':handshake_tone2:',
  category: 'people'
}, {
  unicode: '1f91d-1f3fd',
  shortname: ':handshake_tone3:',
  category: 'people'
}, {
  unicode: '1f91d-1f3fe',
  shortname: ':handshake_tone4:',
  category: 'people'
}, {
  unicode: '1f91d-1f3ff',
  shortname: ':handshake_tone5:',
  category: 'people'
}, {
  unicode: '1f485',
  shortname: ':nail_care:',
  category: 'people'
}, {
  unicode: '1f485-1f3fb',
  shortname: ':nail_care_tone1:',
  category: 'people'
}, {
  unicode: '1f485-1f3fc',
  shortname: ':nail_care_tone2:',
  category: 'people'
}, {
  unicode: '1f485-1f3fd',
  shortname: ':nail_care_tone3:',
  category: 'people'
}, {
  unicode: '1f485-1f3fe',
  shortname: ':nail_care_tone4:',
  category: 'people'
}, {
  unicode: '1f485-1f3ff',
  shortname: ':nail_care_tone5:',
  category: 'people'
}, {
  unicode: '1f442',
  shortname: ':ear:',
  category: 'people'
}, {
  unicode: '1f442-1f3fb',
  shortname: ':ear_tone1:',
  category: 'people'
}, {
  unicode: '1f442-1f3fc',
  shortname: ':ear_tone2:',
  category: 'people'
}, {
  unicode: '1f442-1f3fd',
  shortname: ':ear_tone3:',
  category: 'people'
}, {
  unicode: '1f442-1f3fe',
  shortname: ':ear_tone4:',
  category: 'people'
}, {
  unicode: '1f442-1f3ff',
  shortname: ':ear_tone5:',
  category: 'people'
}, {
  unicode: '1f443',
  shortname: ':nose:',
  category: 'people'
}, {
  unicode: '1f443-1f3fb',
  shortname: ':nose_tone1:',
  category: 'people'
}, {
  unicode: '1f443-1f3fc',
  shortname: ':nose_tone2:',
  category: 'people'
}, {
  unicode: '1f443-1f3fd',
  shortname: ':nose_tone3:',
  category: 'people'
}, {
  unicode: '1f443-1f3fe',
  shortname: ':nose_tone4:',
  category: 'people'
}, {
  unicode: '1f443-1f3ff',
  shortname: ':nose_tone5:',
  category: 'people'
}, {
  unicode: '1f463',
  shortname: ':footprints:',
  category: 'people'
}, {
  unicode: '1f440',
  shortname: ':eyes:',
  category: 'people'
}, {
  unicode: '1f441',
  shortname: ':eye:',
  category: 'people'
}, {
  unicode: '1f445',
  shortname: ':tongue:',
  category: 'people'
}, {
  unicode: '1f444',
  shortname: ':lips:',
  category: 'people'
}, {
  unicode: '1f48b',
  shortname: ':kiss:',
  category: 'people'
}, {
  unicode: '1f4a4',
  shortname: ':zzz:',
  category: 'people'
}, {
  unicode: '1f453',
  shortname: ':eyeglasses:',
  category: 'people'
}, {
  unicode: '1f576',
  shortname: ':dark_sunglasses:',
  category: 'people'
}, {
  unicode: '1f454',
  shortname: ':necktie:',
  category: 'people'
}, {
  unicode: '1f455',
  shortname: ':shirt:',
  category: 'people'
}, {
  unicode: '1f456',
  shortname: ':jeans:',
  category: 'people'
}, {
  unicode: '1f457',
  shortname: ':dress:',
  category: 'people'
}, {
  unicode: '1f458',
  shortname: ':kimono:',
  category: 'people'
}, {
  unicode: '1f459',
  shortname: ':bikini:',
  category: 'people'
}, {
  unicode: '1f45a',
  shortname: ':womans_clothes:',
  category: 'people'
}, {
  unicode: '1f45b',
  shortname: ':purse:',
  category: 'people'
}, {
  unicode: '1f45c',
  shortname: ':handbag:',
  category: 'people'
}, {
  unicode: '1f45d',
  shortname: ':pouch:',
  category: 'people'
}, {
  unicode: '1f392',
  shortname: ':school_satchel:',
  category: 'people'
}, {
  unicode: '1f45e',
  shortname: ':mans_shoe:',
  category: 'people'
}, {
  unicode: '1f45f',
  shortname: ':athletic_shoe:',
  category: 'people'
}, {
  unicode: '1f460',
  shortname: ':high_heel:',
  category: 'people'
}, {
  unicode: '1f461',
  shortname: ':sandal:',
  category: 'people'
}, {
  unicode: '1f462',
  shortname: ':boot:',
  category: 'people'
}, {
  unicode: '1f451',
  shortname: ':crown:',
  category: 'people'
}, {
  unicode: '1f452',
  shortname: ':womans_hat:',
  category: 'people'
}, {
  unicode: '1f3a9',
  shortname: ':tophat:',
  category: 'people'
}, {
  unicode: '1f393',
  shortname: ':mortar_board:',
  category: 'people'
}, {
  unicode: '26d1',
  shortname: ':helmet_with_cross:',
  category: 'people'
}, {
  unicode: '1f484',
  shortname: ':lipstick:',
  category: 'people'
}, {
  unicode: '1f48d',
  shortname: ':ring:',
  category: 'people'
}, {
  unicode: '1f302',
  shortname: ':closed_umbrella:',
  category: 'people'
}, {
  unicode: '1f4bc',
  shortname: ':briefcase:',
  category: 'people'
}, {
  unicode: '1f1ff',
  shortname: ':regional_indicator_z:',
  category: 'regional'
}, {
  unicode: '1f1fe',
  shortname: ':regional_indicator_y:',
  category: 'regional'
}, {
  unicode: '1f1fd',
  shortname: ':regional_indicator_x:',
  category: 'regional'
}, {
  unicode: '1f1fc',
  shortname: ':regional_indicator_w:',
  category: 'regional'
}, {
  unicode: '1f1fb',
  shortname: ':regional_indicator_v:',
  category: 'regional'
}, {
  unicode: '1f1fa',
  shortname: ':regional_indicator_u:',
  category: 'regional'
}, {
  unicode: '1f1f9',
  shortname: ':regional_indicator_t:',
  category: 'regional'
}, {
  unicode: '1f1f8',
  shortname: ':regional_indicator_s:',
  category: 'regional'
}, {
  unicode: '1f1f7',
  shortname: ':regional_indicator_r:',
  category: 'regional'
}, {
  unicode: '1f1f6',
  shortname: ':regional_indicator_q:',
  category: 'regional'
}, {
  unicode: '1f1f5',
  shortname: ':regional_indicator_p:',
  category: 'regional'
}, {
  unicode: '1f1f4',
  shortname: ':regional_indicator_o:',
  category: 'regional'
}, {
  unicode: '1f1f3',
  shortname: ':regional_indicator_n:',
  category: 'regional'
}, {
  unicode: '1f1f2',
  shortname: ':regional_indicator_m:',
  category: 'regional'
}, {
  unicode: '1f1f1',
  shortname: ':regional_indicator_l:',
  category: 'regional'
}, {
  unicode: '1f1f0',
  shortname: ':regional_indicator_k:',
  category: 'regional'
}, {
  unicode: '1f1ef',
  shortname: ':regional_indicator_j:',
  category: 'regional'
}, {
  unicode: '1f1ee',
  shortname: ':regional_indicator_i:',
  category: 'regional'
}, {
  unicode: '1f1ed',
  shortname: ':regional_indicator_h:',
  category: 'regional'
}, {
  unicode: '1f1ec',
  shortname: ':regional_indicator_g:',
  category: 'regional'
}, {
  unicode: '1f1eb',
  shortname: ':regional_indicator_f:',
  category: 'regional'
}, {
  unicode: '1f1ea',
  shortname: ':regional_indicator_e:',
  category: 'regional'
}, {
  unicode: '1f1e9',
  shortname: ':regional_indicator_d:',
  category: 'regional'
}, {
  unicode: '1f1e8',
  shortname: ':regional_indicator_c:',
  category: 'regional'
}, {
  unicode: '1f1e7',
  shortname: ':regional_indicator_b:',
  category: 'regional'
}, {
  unicode: '1f1e6',
  shortname: ':regional_indicator_a:',
  category: 'regional'
}, {
  unicode: '1f441-1f5e8',
  shortname: ':eye_in_speech_bubble:',
  category: 'symbols'
}, {
  unicode: '1f498',
  shortname: ':cupid:',
  category: 'symbols'
}, {
  unicode: '2764',
  shortname: ':heart:',
  category: 'symbols'
}, {
  unicode: '1f493',
  shortname: ':heartbeat:',
  category: 'symbols'
}, {
  unicode: '1f494',
  shortname: ':broken_heart:',
  category: 'symbols'
}, {
  unicode: '1f495',
  shortname: ':two_hearts:',
  category: 'symbols'
}, {
  unicode: '1f496',
  shortname: ':sparkling_heart:',
  category: 'symbols'
}, {
  unicode: '1f497',
  shortname: ':heartpulse:',
  category: 'symbols'
}, {
  unicode: '1f499',
  shortname: ':blue_heart:',
  category: 'symbols'
}, {
  unicode: '1f49a',
  shortname: ':green_heart:',
  category: 'symbols'
}, {
  unicode: '1f49b',
  shortname: ':yellow_heart:',
  category: 'symbols'
}, {
  unicode: '1f49c',
  shortname: ':purple_heart:',
  category: 'symbols'
}, {
  unicode: '1f5a4',
  shortname: ':black_heart:',
  category: 'symbols'
}, {
  unicode: '1f49d',
  shortname: ':gift_heart:',
  category: 'symbols'
}, {
  unicode: '1f49e',
  shortname: ':revolving_hearts:',
  category: 'symbols'
}, {
  unicode: '1f49f',
  shortname: ':heart_decoration:',
  category: 'symbols'
}, {
  unicode: '2763',
  shortname: ':heart_exclamation:',
  category: 'symbols'
}, {
  unicode: '1f4a2',
  shortname: ':anger:',
  category: 'symbols'
}, {
  unicode: '1f4a5',
  shortname: ':boom:',
  category: 'symbols'
}, {
  unicode: '1f4ab',
  shortname: ':dizzy:',
  category: 'symbols'
}, {
  unicode: '1f4ac',
  shortname: ':speech_balloon:',
  category: 'symbols'
}, {
  unicode: '1f5e8',
  shortname: ':speech_left:',
  category: 'symbols'
}, {
  unicode: '1f5ef',
  shortname: ':anger_right:',
  category: 'symbols'
}, {
  unicode: '1f4ad',
  shortname: ':thought_balloon:',
  category: 'symbols'
}, {
  unicode: '1f4ae',
  shortname: ':white_flower:',
  category: 'symbols'
}, {
  unicode: '1f310',
  shortname: ':globe_with_meridians:',
  category: 'symbols'
}, {
  unicode: '2668',
  shortname: ':hotsprings:',
  category: 'symbols'
}, {
  unicode: '1f6d1',
  shortname: ':octagonal_sign:',
  category: 'symbols'
}, {
  unicode: '1f55b',
  shortname: ':clock12:',
  category: 'symbols'
}, {
  unicode: '1f567',
  shortname: ':clock1230:',
  category: 'symbols'
}, {
  unicode: '1f550',
  shortname: ':clock1:',
  category: 'symbols'
}, {
  unicode: '1f55c',
  shortname: ':clock130:',
  category: 'symbols'
}, {
  unicode: '1f551',
  shortname: ':clock2:',
  category: 'symbols'
}, {
  unicode: '1f55d',
  shortname: ':clock230:',
  category: 'symbols'
}, {
  unicode: '1f552',
  shortname: ':clock3:',
  category: 'symbols'
}, {
  unicode: '1f55e',
  shortname: ':clock330:',
  category: 'symbols'
}, {
  unicode: '1f553',
  shortname: ':clock4:',
  category: 'symbols'
}, {
  unicode: '1f55f',
  shortname: ':clock430:',
  category: 'symbols'
}, {
  unicode: '1f554',
  shortname: ':clock5:',
  category: 'symbols'
}, {
  unicode: '1f560',
  shortname: ':clock530:',
  category: 'symbols'
}, {
  unicode: '1f555',
  shortname: ':clock6:',
  category: 'symbols'
}, {
  unicode: '1f561',
  shortname: ':clock630:',
  category: 'symbols'
}, {
  unicode: '1f556',
  shortname: ':clock7:',
  category: 'symbols'
}, {
  unicode: '1f562',
  shortname: ':clock730:',
  category: 'symbols'
}, {
  unicode: '1f557',
  shortname: ':clock8:',
  category: 'symbols'
}, {
  unicode: '1f563',
  shortname: ':clock830:',
  category: 'symbols'
}, {
  unicode: '1f558',
  shortname: ':clock9:',
  category: 'symbols'
}, {
  unicode: '1f564',
  shortname: ':clock930:',
  category: 'symbols'
}, {
  unicode: '1f559',
  shortname: ':clock10:',
  category: 'symbols'
}, {
  unicode: '1f565',
  shortname: ':clock1030:',
  category: 'symbols'
}, {
  unicode: '1f55a',
  shortname: ':clock11:',
  category: 'symbols'
}, {
  unicode: '1f566',
  shortname: ':clock1130:',
  category: 'symbols'
}, {
  unicode: '1f300',
  shortname: ':cyclone:',
  category: 'symbols'
}, {
  unicode: '2660',
  shortname: ':spades:',
  category: 'symbols'
}, {
  unicode: '2665',
  shortname: ':hearts:',
  category: 'symbols'
}, {
  unicode: '2666',
  shortname: ':diamonds:',
  category: 'symbols'
}, {
  unicode: '2663',
  shortname: ':clubs:',
  category: 'symbols'
}, {
  unicode: '1f0cf',
  shortname: ':black_joker:',
  category: 'symbols'
}, {
  unicode: '1f004',
  shortname: ':mahjong:',
  category: 'symbols'
}, {
  unicode: '1f3b4',
  shortname: ':flower_playing_cards:',
  category: 'symbols'
}, {
  unicode: '1f507',
  shortname: ':mute:',
  category: 'symbols'
}, {
  unicode: '1f508',
  shortname: ':speaker:',
  category: 'symbols'
}, {
  unicode: '1f509',
  shortname: ':sound:',
  category: 'symbols'
}, {
  unicode: '1f50a',
  shortname: ':loud_sound:',
  category: 'symbols'
}, {
  unicode: '1f4e2',
  shortname: ':loudspeaker:',
  category: 'symbols'
}, {
  unicode: '1f4e3',
  shortname: ':mega:',
  category: 'symbols'
}, {
  unicode: '1f514',
  shortname: ':bell:',
  category: 'symbols'
}, {
  unicode: '1f515',
  shortname: ':no_bell:',
  category: 'symbols'
}, {
  unicode: '1f3b5',
  shortname: ':musical_note:',
  category: 'symbols'
}, {
  unicode: '1f3b6',
  shortname: ':notes:',
  category: 'symbols'
}, {
  unicode: '1f4b9',
  shortname: ':chart:',
  category: 'symbols'
}, {
  unicode: '1f4b1',
  shortname: ':currency_exchange:',
  category: 'symbols'
}, {
  unicode: '1f4b2',
  shortname: ':heavy_dollar_sign:',
  category: 'symbols'
}, {
  unicode: '1f3e7',
  shortname: ':atm:',
  category: 'symbols'
}, {
  unicode: '1f6ae',
  shortname: ':put_litter_in_its_place:',
  category: 'symbols'
}, {
  unicode: '1f6b0',
  shortname: ':potable_water:',
  category: 'symbols'
}, {
  unicode: '267f',
  shortname: ':wheelchair:',
  category: 'symbols'
}, {
  unicode: '1f6b9',
  shortname: ':mens:',
  category: 'symbols'
}, {
  unicode: '1f6ba',
  shortname: ':womens:',
  category: 'symbols'
}, {
  unicode: '1f6bb',
  shortname: ':restroom:',
  category: 'symbols'
}, {
  unicode: '1f6bc',
  shortname: ':baby_symbol:',
  category: 'symbols'
}, {
  unicode: '1f6be',
  shortname: ':wc:',
  category: 'symbols'
}, {
  unicode: '1f6c2',
  shortname: ':passport_control:',
  category: 'symbols'
}, {
  unicode: '1f6c3',
  shortname: ':customs:',
  category: 'symbols'
}, {
  unicode: '1f6c4',
  shortname: ':baggage_claim:',
  category: 'symbols'
}, {
  unicode: '1f6c5',
  shortname: ':left_luggage:',
  category: 'symbols'
}, {
  unicode: '26a0',
  shortname: ':warning:',
  category: 'symbols'
}, {
  unicode: '1f6b8',
  shortname: ':children_crossing:',
  category: 'symbols'
}, {
  unicode: '26d4',
  shortname: ':no_entry:',
  category: 'symbols'
}, {
  unicode: '1f6ab',
  shortname: ':no_entry_sign:',
  category: 'symbols'
}, {
  unicode: '1f6b3',
  shortname: ':no_bicycles:',
  category: 'symbols'
}, {
  unicode: '1f6ad',
  shortname: ':no_smoking:',
  category: 'symbols'
}, {
  unicode: '1f6af',
  shortname: ':do_not_litter:',
  category: 'symbols'
}, {
  unicode: '1f6b1',
  shortname: ':non-potable_water:',
  category: 'symbols'
}, {
  unicode: '1f6b7',
  shortname: ':no_pedestrians:',
  category: 'symbols'
}, {
  unicode: '1f4f5',
  shortname: ':no_mobile_phones:',
  category: 'symbols'
}, {
  unicode: '1f51e',
  shortname: ':underage:',
  category: 'symbols'
}, {
  unicode: '2622',
  shortname: ':radioactive:',
  category: 'symbols'
}, {
  unicode: '2623',
  shortname: ':biohazard:',
  category: 'symbols'
}, {
  unicode: '2b06',
  shortname: ':arrow_up:',
  category: 'symbols'
}, {
  unicode: '2197',
  shortname: ':arrow_upper_right:',
  category: 'symbols'
}, {
  unicode: '27a1',
  shortname: ':arrow_right:',
  category: 'symbols'
}, {
  unicode: '2198',
  shortname: ':arrow_lower_right:',
  category: 'symbols'
}, {
  unicode: '2b07',
  shortname: ':arrow_down:',
  category: 'symbols'
}, {
  unicode: '2199',
  shortname: ':arrow_lower_left:',
  category: 'symbols'
}, {
  unicode: '2b05',
  shortname: ':arrow_left:',
  category: 'symbols'
}, {
  unicode: '2196',
  shortname: ':arrow_upper_left:',
  category: 'symbols'
}, {
  unicode: '2195',
  shortname: ':arrow_up_down:',
  category: 'symbols'
}, {
  unicode: '2194',
  shortname: ':left_right_arrow:',
  category: 'symbols'
}, {
  unicode: '21a9',
  shortname: ':leftwards_arrow_with_hook:',
  category: 'symbols'
}, {
  unicode: '21aa',
  shortname: ':arrow_right_hook:',
  category: 'symbols'
}, {
  unicode: '2934',
  shortname: ':arrow_heading_up:',
  category: 'symbols'
}, {
  unicode: '2935',
  shortname: ':arrow_heading_down:',
  category: 'symbols'
}, {
  unicode: '1f503',
  shortname: ':arrows_clockwise:',
  category: 'symbols'
}, {
  unicode: '1f504',
  shortname: ':arrows_counterclockwise:',
  category: 'symbols'
}, {
  unicode: '1f519',
  shortname: ':back:',
  category: 'symbols'
}, {
  unicode: '1f51a',
  shortname: ':end:',
  category: 'symbols'
}, {
  unicode: '1f51b',
  shortname: ':on:',
  category: 'symbols'
}, {
  unicode: '1f51c',
  shortname: ':soon:',
  category: 'symbols'
}, {
  unicode: '1f51d',
  shortname: ':top:',
  category: 'symbols'
}, {
  unicode: '1f6d0',
  shortname: ':place_of_worship:',
  category: 'symbols'
}, {
  unicode: '269b',
  shortname: ':atom:',
  category: 'symbols'
}, {
  unicode: '1f549',
  shortname: ':om_symbol:',
  category: 'symbols'
}, {
  unicode: '2721',
  shortname: ':star_of_david:',
  category: 'symbols'
}, {
  unicode: '2638',
  shortname: ':wheel_of_dharma:',
  category: 'symbols'
}, {
  unicode: '262f',
  shortname: ':yin_yang:',
  category: 'symbols'
}, {
  unicode: '271d',
  shortname: ':cross:',
  category: 'symbols'
}, {
  unicode: '2626',
  shortname: ':orthodox_cross:',
  category: 'symbols'
}, {
  unicode: '262a',
  shortname: ':star_and_crescent:',
  category: 'symbols'
}, {
  unicode: '262e',
  shortname: ':peace:',
  category: 'symbols'
}, {
  unicode: '1f54e',
  shortname: ':menorah:',
  category: 'symbols'
}, {
  unicode: '1f52f',
  shortname: ':six_pointed_star:',
  category: 'symbols'
}, {
  unicode: '2648',
  shortname: ':aries:',
  category: 'symbols'
}, {
  unicode: '2649',
  shortname: ':taurus:',
  category: 'symbols'
}, {
  unicode: '264a',
  shortname: ':gemini:',
  category: 'symbols'
}, {
  unicode: '264b',
  shortname: ':cancer:',
  category: 'symbols'
}, {
  unicode: '264c',
  shortname: ':leo:',
  category: 'symbols'
}, {
  unicode: '264d',
  shortname: ':virgo:',
  category: 'symbols'
}, {
  unicode: '264e',
  shortname: ':libra:',
  category: 'symbols'
}, {
  unicode: '264f',
  shortname: ':scorpius:',
  category: 'symbols'
}, {
  unicode: '2650',
  shortname: ':sagittarius:',
  category: 'symbols'
}, {
  unicode: '2651',
  shortname: ':capricorn:',
  category: 'symbols'
}, {
  unicode: '2652',
  shortname: ':aquarius:',
  category: 'symbols'
}, {
  unicode: '2653',
  shortname: ':pisces:',
  category: 'symbols'
}, {
  unicode: '26ce',
  shortname: ':ophiuchus:',
  category: 'symbols'
}, {
  unicode: '1f500',
  shortname: ':twisted_rightwards_arrows:',
  category: 'symbols'
}, {
  unicode: '1f501',
  shortname: ':repeat:',
  category: 'symbols'
}, {
  unicode: '1f502',
  shortname: ':repeat_one:',
  category: 'symbols'
}, {
  unicode: '25b6',
  shortname: ':arrow_forward:',
  category: 'symbols'
}, {
  unicode: '23e9',
  shortname: ':fast_forward:',
  category: 'symbols'
}, {
  unicode: '23ed',
  shortname: ':track_next:',
  category: 'symbols'
}, {
  unicode: '23ef',
  shortname: ':play_pause:',
  category: 'symbols'
}, {
  unicode: '25c0',
  shortname: ':arrow_backward:',
  category: 'symbols'
}, {
  unicode: '23ea',
  shortname: ':rewind:',
  category: 'symbols'
}, {
  unicode: '23ee',
  shortname: ':track_previous:',
  category: 'symbols'
}, {
  unicode: '1f53c',
  shortname: ':arrow_up_small:',
  category: 'symbols'
}, {
  unicode: '23eb',
  shortname: ':arrow_double_up:',
  category: 'symbols'
}, {
  unicode: '1f53d',
  shortname: ':arrow_down_small:',
  category: 'symbols'
}, {
  unicode: '23ec',
  shortname: ':arrow_double_down:',
  category: 'symbols'
}, {
  unicode: '23f8',
  shortname: ':pause_button:',
  category: 'symbols'
}, {
  unicode: '23f9',
  shortname: ':stop_button:',
  category: 'symbols'
}, {
  unicode: '23fa',
  shortname: ':record_button:',
  category: 'symbols'
}, {
  unicode: '23cf',
  shortname: ':eject:',
  category: 'symbols'
}, {
  unicode: '1f3a6',
  shortname: ':cinema:',
  category: 'symbols'
}, {
  unicode: '1f505',
  shortname: ':low_brightness:',
  category: 'symbols'
}, {
  unicode: '1f506',
  shortname: ':high_brightness:',
  category: 'symbols'
}, {
  unicode: '1f4f6',
  shortname: ':signal_strength:',
  category: 'symbols'
}, {
  unicode: '1f4f3',
  shortname: ':vibration_mode:',
  category: 'symbols'
}, {
  unicode: '1f4f4',
  shortname: ':mobile_phone_off:',
  category: 'symbols'
}, {
  unicode: '267b',
  shortname: ':recycle:',
  category: 'symbols'
}, {
  unicode: '1f4db',
  shortname: ':name_badge:',
  category: 'symbols'
}, {
  unicode: '269c',
  shortname: ':fleur-de-lis:',
  category: 'symbols'
}, {
  unicode: '1f530',
  shortname: ':beginner:',
  category: 'symbols'
}, {
  unicode: '1f531',
  shortname: ':trident:',
  category: 'symbols'
}, {
  unicode: '2b55',
  shortname: ':o:',
  category: 'symbols'
}, {
  unicode: '2705',
  shortname: ':white_check_mark:',
  category: 'symbols'
}, {
  unicode: '2611',
  shortname: ':ballot_box_with_check:',
  category: 'symbols'
}, {
  unicode: '2714',
  shortname: ':heavy_check_mark:',
  category: 'symbols'
}, {
  unicode: '2716',
  shortname: ':heavy_multiplication_x:',
  category: 'symbols'
}, {
  unicode: '274c',
  shortname: ':x:',
  category: 'symbols'
}, {
  unicode: '274e',
  shortname: ':negative_squared_cross_mark:',
  category: 'symbols'
}, {
  unicode: '2795',
  shortname: ':heavy_plus_sign:',
  category: 'symbols'
}, {
  unicode: '2796',
  shortname: ':heavy_minus_sign:',
  category: 'symbols'
}, {
  unicode: '2797',
  shortname: ':heavy_division_sign:',
  category: 'symbols'
}, {
  unicode: '27b0',
  shortname: ':curly_loop:',
  category: 'symbols'
}, {
  unicode: '27bf',
  shortname: ':loop:',
  category: 'symbols'
}, {
  unicode: '303d',
  shortname: ':part_alternation_mark:',
  category: 'symbols'
}, {
  unicode: '2733',
  shortname: ':eight_spoked_asterisk:',
  category: 'symbols'
}, {
  unicode: '2734',
  shortname: ':eight_pointed_black_star:',
  category: 'symbols'
}, {
  unicode: '2747',
  shortname: ':sparkle:',
  category: 'symbols'
}, {
  unicode: '203c',
  shortname: ':bangbang:',
  category: 'symbols'
}, {
  unicode: '2049',
  shortname: ':interrobang:',
  category: 'symbols'
}, {
  unicode: '2753',
  shortname: ':question:',
  category: 'symbols'
}, {
  unicode: '2754',
  shortname: ':grey_question:',
  category: 'symbols'
}, {
  unicode: '2755',
  shortname: ':grey_exclamation:',
  category: 'symbols'
}, {
  unicode: '2757',
  shortname: ':exclamation:',
  category: 'symbols'
}, {
  unicode: '3030',
  shortname: ':wavy_dash:',
  category: 'symbols'
}, {
  unicode: '00a9',
  shortname: ':copyright:',
  category: 'symbols'
}, {
  unicode: '00ae',
  shortname: ':registered:',
  category: 'symbols'
}, {
  unicode: '2122',
  shortname: ':tm:',
  category: 'symbols'
}, {
  unicode: '0023-20e3',
  shortname: ':hash:',
  category: 'symbols'
}, {
  unicode: '002a-20e3',
  shortname: ':asterisk:',
  category: 'symbols'
}, {
  unicode: '0030-20e3',
  shortname: ':zero:',
  category: 'symbols'
}, {
  unicode: '0031-20e3',
  shortname: ':one:',
  category: 'symbols'
}, {
  unicode: '0032-20e3',
  shortname: ':two:',
  category: 'symbols'
}, {
  unicode: '0033-20e3',
  shortname: ':three:',
  category: 'symbols'
}, {
  unicode: '0034-20e3',
  shortname: ':four:',
  category: 'symbols'
}, {
  unicode: '0035-20e3',
  shortname: ':five:',
  category: 'symbols'
}, {
  unicode: '0036-20e3',
  shortname: ':six:',
  category: 'symbols'
}, {
  unicode: '0037-20e3',
  shortname: ':seven:',
  category: 'symbols'
}, {
  unicode: '0038-20e3',
  shortname: ':eight:',
  category: 'symbols'
}, {
  unicode: '0039-20e3',
  shortname: ':nine:',
  category: 'symbols'
}, {
  unicode: '1f51f',
  shortname: ':keycap_ten:',
  category: 'symbols'
}, {
  unicode: '1f4af',
  shortname: ':100:',
  category: 'symbols'
}, {
  unicode: '1f520',
  shortname: ':capital_abcd:',
  category: 'symbols'
}, {
  unicode: '1f521',
  shortname: ':abcd:',
  category: 'symbols'
}, {
  unicode: '1f522',
  shortname: ':1234:',
  category: 'symbols'
}, {
  unicode: '1f523',
  shortname: ':symbols:',
  category: 'symbols'
}, {
  unicode: '1f524',
  shortname: ':abc:',
  category: 'symbols'
}, {
  unicode: '1f170',
  shortname: ':a:',
  category: 'symbols'
}, {
  unicode: '1f18e',
  shortname: ':ab:',
  category: 'symbols'
}, {
  unicode: '1f171',
  shortname: ':b:',
  category: 'symbols'
}, {
  unicode: '1f191',
  shortname: ':cl:',
  category: 'symbols'
}, {
  unicode: '1f192',
  shortname: ':cool:',
  category: 'symbols'
}, {
  unicode: '1f193',
  shortname: ':free:',
  category: 'symbols'
}, {
  unicode: '2139',
  shortname: ':information_source:',
  category: 'symbols'
}, {
  unicode: '1f194',
  shortname: ':id:',
  category: 'symbols'
}, {
  unicode: '24c2',
  shortname: ':m:',
  category: 'symbols'
}, {
  unicode: '1f195',
  shortname: ':new:',
  category: 'symbols'
}, {
  unicode: '1f196',
  shortname: ':ng:',
  category: 'symbols'
}, {
  unicode: '1f17e',
  shortname: ':o2:',
  category: 'symbols'
}, {
  unicode: '1f197',
  shortname: ':ok:',
  category: 'symbols'
}, {
  unicode: '1f17f',
  shortname: ':parking:',
  category: 'symbols'
}, {
  unicode: '1f198',
  shortname: ':sos:',
  category: 'symbols'
}, {
  unicode: '1f199',
  shortname: ':up:',
  category: 'symbols'
}, {
  unicode: '1f19a',
  shortname: ':vs:',
  category: 'symbols'
}, {
  unicode: '1f201',
  shortname: ':koko:',
  category: 'symbols'
}, {
  unicode: '1f202',
  shortname: ':sa:',
  category: 'symbols'
}, {
  unicode: '1f237',
  shortname: ':u6708:',
  category: 'symbols'
}, {
  unicode: '1f236',
  shortname: ':u6709:',
  category: 'symbols'
}, {
  unicode: '1f22f',
  shortname: ':u6307:',
  category: 'symbols'
}, {
  unicode: '1f250',
  shortname: ':ideograph_advantage:',
  category: 'symbols'
}, {
  unicode: '1f239',
  shortname: ':u5272:',
  category: 'symbols'
}, {
  unicode: '1f21a',
  shortname: ':u7121:',
  category: 'symbols'
}, {
  unicode: '1f232',
  shortname: ':u7981:',
  category: 'symbols'
}, {
  unicode: '1f251',
  shortname: ':accept:',
  category: 'symbols'
}, {
  unicode: '1f238',
  shortname: ':u7533:',
  category: 'symbols'
}, {
  unicode: '1f234',
  shortname: ':u5408:',
  category: 'symbols'
}, {
  unicode: '1f233',
  shortname: ':u7a7a:',
  category: 'symbols'
}, {
  unicode: '3297',
  shortname: ':congratulations:',
  category: 'symbols'
}, {
  unicode: '3299',
  shortname: ':secret:',
  category: 'symbols'
}, {
  unicode: '1f23a',
  shortname: ':u55b6:',
  category: 'symbols'
}, {
  unicode: '1f235',
  shortname: ':u6e80:',
  category: 'symbols'
}, {
  unicode: '25aa',
  shortname: ':black_small_square:',
  category: 'symbols'
}, {
  unicode: '25ab',
  shortname: ':white_small_square:',
  category: 'symbols'
}, {
  unicode: '25fb',
  shortname: ':white_medium_square:',
  category: 'symbols'
}, {
  unicode: '25fc',
  shortname: ':black_medium_square:',
  category: 'symbols'
}, {
  unicode: '25fd',
  shortname: ':white_medium_small_square:',
  category: 'symbols'
}, {
  unicode: '25fe',
  shortname: ':black_medium_small_square:',
  category: 'symbols'
}, {
  unicode: '2b1b',
  shortname: ':black_large_square:',
  category: 'symbols'
}, {
  unicode: '2b1c',
  shortname: ':white_large_square:',
  category: 'symbols'
}, {
  unicode: '1f536',
  shortname: ':large_orange_diamond:',
  category: 'symbols'
}, {
  unicode: '1f537',
  shortname: ':large_blue_diamond:',
  category: 'symbols'
}, {
  unicode: '1f538',
  shortname: ':small_orange_diamond:',
  category: 'symbols'
}, {
  unicode: '1f539',
  shortname: ':small_blue_diamond:',
  category: 'symbols'
}, {
  unicode: '1f53a',
  shortname: ':small_red_triangle:',
  category: 'symbols'
}, {
  unicode: '1f53b',
  shortname: ':small_red_triangle_down:',
  category: 'symbols'
}, {
  unicode: '1f4a0',
  shortname: ':diamond_shape_with_a_dot_inside:',
  category: 'symbols'
}, {
  unicode: '1f518',
  shortname: ':radio_button:',
  category: 'symbols'
}, {
  unicode: '1f532',
  shortname: ':black_square_button:',
  category: 'symbols'
}, {
  unicode: '1f533',
  shortname: ':white_square_button:',
  category: 'symbols'
}, {
  unicode: '26aa',
  shortname: ':white_circle:',
  category: 'symbols'
}, {
  unicode: '26ab',
  shortname: ':black_circle:',
  category: 'symbols'
}, {
  unicode: '1f534',
  shortname: ':red_circle:',
  category: 'symbols'
}, {
  unicode: '1f535',
  shortname: ':blue_circle:',
  category: 'symbols'
}, {
  unicode: '1f3ce',
  shortname: ':race_car:',
  category: 'travel'
}, {
  unicode: '1f3cd',
  shortname: ':motorcycle:',
  category: 'travel'
}, {
  unicode: '1f5fe',
  shortname: ':japan:',
  category: 'travel'
}, {
  unicode: '1f3d4',
  shortname: ':mountain_snow:',
  category: 'travel'
}, {
  unicode: '26f0',
  shortname: ':mountain:',
  category: 'travel'
}, {
  unicode: '1f30b',
  shortname: ':volcano:',
  category: 'travel'
}, {
  unicode: '1f5fb',
  shortname: ':mount_fuji:',
  category: 'travel'
}, {
  unicode: '1f3d5',
  shortname: ':camping:',
  category: 'travel'
}, {
  unicode: '1f3d6',
  shortname: ':beach:',
  category: 'travel'
}, {
  unicode: '1f3dc',
  shortname: ':desert:',
  category: 'travel'
}, {
  unicode: '1f3dd',
  shortname: ':island:',
  category: 'travel'
}, {
  unicode: '1f3de',
  shortname: ':park:',
  category: 'travel'
}, {
  unicode: '1f3df',
  shortname: ':stadium:',
  category: 'travel'
}, {
  unicode: '1f3db',
  shortname: ':classical_building:',
  category: 'travel'
}, {
  unicode: '1f3d7',
  shortname: ':construction_site:',
  category: 'travel'
}, {
  unicode: '1f3d8',
  shortname: ':homes:',
  category: 'travel'
}, {
  unicode: '1f3d9',
  shortname: ':cityscape:',
  category: 'travel'
}, {
  unicode: '1f3da',
  shortname: ':house_abandoned:',
  category: 'travel'
}, {
  unicode: '1f3e0',
  shortname: ':house:',
  category: 'travel'
}, {
  unicode: '1f3e1',
  shortname: ':house_with_garden:',
  category: 'travel'
}, {
  unicode: '1f3e2',
  shortname: ':office:',
  category: 'travel'
}, {
  unicode: '1f3e3',
  shortname: ':post_office:',
  category: 'travel'
}, {
  unicode: '1f3e4',
  shortname: ':european_post_office:',
  category: 'travel'
}, {
  unicode: '1f3e5',
  shortname: ':hospital:',
  category: 'travel'
}, {
  unicode: '1f3e6',
  shortname: ':bank:',
  category: 'travel'
}, {
  unicode: '1f3e8',
  shortname: ':hotel:',
  category: 'travel'
}, {
  unicode: '1f3e9',
  shortname: ':love_hotel:',
  category: 'travel'
}, {
  unicode: '1f3ea',
  shortname: ':convenience_store:',
  category: 'travel'
}, {
  unicode: '1f3eb',
  shortname: ':school:',
  category: 'travel'
}, {
  unicode: '1f3ec',
  shortname: ':department_store:',
  category: 'travel'
}, {
  unicode: '1f3ed',
  shortname: ':factory:',
  category: 'travel'
}, {
  unicode: '1f3ef',
  shortname: ':japanese_castle:',
  category: 'travel'
}, {
  unicode: '1f3f0',
  shortname: ':european_castle:',
  category: 'travel'
}, {
  unicode: '1f492',
  shortname: ':wedding:',
  category: 'travel'
}, {
  unicode: '1f5fc',
  shortname: ':tokyo_tower:',
  category: 'travel'
}, {
  unicode: '1f5fd',
  shortname: ':statue_of_liberty:',
  category: 'travel'
}, {
  unicode: '26ea',
  shortname: ':church:',
  category: 'travel'
}, {
  unicode: '1f54c',
  shortname: ':mosque:',
  category: 'travel'
}, {
  unicode: '1f54d',
  shortname: ':synagogue:',
  category: 'travel'
}, {
  unicode: '26e9',
  shortname: ':shinto_shrine:',
  category: 'travel'
}, {
  unicode: '1f54b',
  shortname: ':kaaba:',
  category: 'travel'
}, {
  unicode: '26f2',
  shortname: ':fountain:',
  category: 'travel'
}, {
  unicode: '26fa',
  shortname: ':tent:',
  category: 'travel'
}, {
  unicode: '1f301',
  shortname: ':foggy:',
  category: 'travel'
}, {
  unicode: '1f303',
  shortname: ':night_with_stars:',
  category: 'travel'
}, {
  unicode: '1f304',
  shortname: ':sunrise_over_mountains:',
  category: 'travel'
}, {
  unicode: '1f305',
  shortname: ':sunrise:',
  category: 'travel'
}, {
  unicode: '1f306',
  shortname: ':city_dusk:',
  category: 'travel'
}, {
  unicode: '1f307',
  shortname: ':city_sunset:',
  category: 'travel'
}, {
  unicode: '1f309',
  shortname: ':bridge_at_night:',
  category: 'travel'
}, {
  unicode: '1f30c',
  shortname: ':milky_way:',
  category: 'travel'
}, {
  unicode: '1f3a0',
  shortname: ':carousel_horse:',
  category: 'travel'
}, {
  unicode: '1f3a1',
  shortname: ':ferris_wheel:',
  category: 'travel'
}, {
  unicode: '1f3a2',
  shortname: ':roller_coaster:',
  category: 'travel'
}, {
  unicode: '1f682',
  shortname: ':steam_locomotive:',
  category: 'travel'
}, {
  unicode: '1f683',
  shortname: ':railway_car:',
  category: 'travel'
}, {
  unicode: '1f684',
  shortname: ':bullettrain_side:',
  category: 'travel'
}, {
  unicode: '1f685',
  shortname: ':bullettrain_front:',
  category: 'travel'
}, {
  unicode: '1f686',
  shortname: ':train2:',
  category: 'travel'
}, {
  unicode: '1f687',
  shortname: ':metro:',
  category: 'travel'
}, {
  unicode: '1f688',
  shortname: ':light_rail:',
  category: 'travel'
}, {
  unicode: '1f689',
  shortname: ':station:',
  category: 'travel'
}, {
  unicode: '1f68a',
  shortname: ':tram:',
  category: 'travel'
}, {
  unicode: '1f69d',
  shortname: ':monorail:',
  category: 'travel'
}, {
  unicode: '1f69e',
  shortname: ':mountain_railway:',
  category: 'travel'
}, {
  unicode: '1f68b',
  shortname: ':train:',
  category: 'travel'
}, {
  unicode: '1f68c',
  shortname: ':bus:',
  category: 'travel'
}, {
  unicode: '1f68d',
  shortname: ':oncoming_bus:',
  category: 'travel'
}, {
  unicode: '1f68e',
  shortname: ':trolleybus:',
  category: 'travel'
}, {
  unicode: '1f690',
  shortname: ':minibus:',
  category: 'travel'
}, {
  unicode: '1f691',
  shortname: ':ambulance:',
  category: 'travel'
}, {
  unicode: '1f692',
  shortname: ':fire_engine:',
  category: 'travel'
}, {
  unicode: '1f693',
  shortname: ':police_car:',
  category: 'travel'
}, {
  unicode: '1f694',
  shortname: ':oncoming_police_car:',
  category: 'travel'
}, {
  unicode: '1f695',
  shortname: ':taxi:',
  category: 'travel'
}, {
  unicode: '1f696',
  shortname: ':oncoming_taxi:',
  category: 'travel'
}, {
  unicode: '1f697',
  shortname: ':red_car:',
  category: 'travel'
}, {
  unicode: '1f698',
  shortname: ':oncoming_automobile:',
  category: 'travel'
}, {
  unicode: '1f699',
  shortname: ':blue_car:',
  category: 'travel'
}, {
  unicode: '1f69a',
  shortname: ':truck:',
  category: 'travel'
}, {
  unicode: '1f69b',
  shortname: ':articulated_lorry:',
  category: 'travel'
}, {
  unicode: '1f69c',
  shortname: ':tractor:',
  category: 'travel'
}, {
  unicode: '1f6b2',
  shortname: ':bike:',
  category: 'travel'
}, {
  unicode: '1f6f4',
  shortname: ':scooter:',
  category: 'travel'
}, {
  unicode: '1f6f5',
  shortname: ':motor_scooter:',
  category: 'travel'
}, {
  unicode: '1f68f',
  shortname: ':busstop:',
  category: 'travel'
}, {
  unicode: '1f6e3',
  shortname: ':motorway:',
  category: 'travel'
}, {
  unicode: '1f6e4',
  shortname: ':railway_track:',
  category: 'travel'
}, {
  unicode: '26fd',
  shortname: ':fuelpump:',
  category: 'travel'
}, {
  unicode: '1f6a8',
  shortname: ':rotating_light:',
  category: 'travel'
}, {
  unicode: '1f6a5',
  shortname: ':traffic_light:',
  category: 'travel'
}, {
  unicode: '1f6a6',
  shortname: ':vertical_traffic_light:',
  category: 'travel'
}, {
  unicode: '1f6a7',
  shortname: ':construction:',
  category: 'travel'
}, {
  unicode: '2693',
  shortname: ':anchor:',
  category: 'travel'
}, {
  unicode: '26f5',
  shortname: ':sailboat:',
  category: 'travel'
}, {
  unicode: '1f6f6',
  shortname: ':canoe:',
  category: 'travel'
}, {
  unicode: '1f6a4',
  shortname: ':speedboat:',
  category: 'travel'
}, {
  unicode: '1f6f3',
  shortname: ':cruise_ship:',
  category: 'travel'
}, {
  unicode: '26f4',
  shortname: ':ferry:',
  category: 'travel'
}, {
  unicode: '1f6e5',
  shortname: ':motorboat:',
  category: 'travel'
}, {
  unicode: '1f6a2',
  shortname: ':ship:',
  category: 'travel'
}, {
  unicode: '2708',
  shortname: ':airplane:',
  category: 'travel'
}, {
  unicode: '1f6e9',
  shortname: ':airplane_small:',
  category: 'travel'
}, {
  unicode: '1f6eb',
  shortname: ':airplane_departure:',
  category: 'travel'
}, {
  unicode: '1f6ec',
  shortname: ':airplane_arriving:',
  category: 'travel'
}, {
  unicode: '1f4ba',
  shortname: ':seat:',
  category: 'travel'
}, {
  unicode: '1f681',
  shortname: ':helicopter:',
  category: 'travel'
}, {
  unicode: '1f69f',
  shortname: ':suspension_railway:',
  category: 'travel'
}, {
  unicode: '1f6a0',
  shortname: ':mountain_cableway:',
  category: 'travel'
}, {
  unicode: '1f6a1',
  shortname: ':aerial_tramway:',
  category: 'travel'
}, {
  unicode: '1f680',
  shortname: ':rocket:',
  category: 'travel'
}, {
  unicode: '1f6f0',
  shortname: ':satellite_orbital:',
  category: 'travel'
}, {
  unicode: '1f320',
  shortname: ':stars:',
  category: 'travel'
}, {
  unicode: '1f308',
  shortname: ':rainbow:',
  category: 'travel'
}, {
  unicode: '1f386',
  shortname: ':fireworks:',
  category: 'travel'
}, {
  unicode: '1f387',
  shortname: ':sparkler:',
  category: 'travel'
}, {
  unicode: '1f391',
  shortname: ':rice_scene:',
  category: 'travel'
}, {
  unicode: '1f3c1',
  shortname: ':checkered_flag:',
  category: 'travel'
}];
var _default = EmojiList;
exports.default = _default;